import {
    Box, Button, Checkbox, FormControlLabel, Grid, Grow, IconButton, InputAdornment, Paper, Radio, RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField, Tooltip, Typography, Collapse,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Modal,
    Divider,
    Autocomplete,
} from '@mui/material';
import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { newAmountCard } from '../../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Colors } from '../../../../Styles/Colors';
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from '../../../../Utility/Constants';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import CashSplitter from '../../../../Components/Common Components/CashSpliter';
import './commonBilling.css';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditIcon from "@mui/icons-material/Edit";
import { AmountFormat, checkTransationMandatory, ContentInTooltip, debounce, formatDateAndTimeMeth2, CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import Loader from '../../../../Components/Loader';
import { BillSuccessPoPUp, CommonPatientDetails, renderInsCorpDetails } from '../../../../Components/Common Components/CommonComponents';
import { clearCachevalue, getCachevalue, localGetItem, localSetItem } from '../../../../Utility/Services/CacheProviderService';
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { DateTime } from 'luxon';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


const STYLES = {
    FONT_SIZE_LOW: '0.8rem',
    FONT_SIZE_MED: '0.9rem',
    BACKGROUND_COLOR: '#F5F8F7',
    BOX_BACKGROUND_COLOR: 'white',
    TEXT_BOX_HEIGHT: '4.5dvh',
    FONT_WEIGHT: 600,
    FONT_SIZE_LOW_2: '0.85rem',
    MAIN_CARD_HEIGHT: '70dvh',
    FONT_SIZE_LOW_3: '0.7rem'
}

const genderMap = { m: 'M', f: 'F', t: 'T' };
/** Matches row visibility in the settle bill-details table (this condition is used to show the row in the table same condition is used in the overall select also). */
const billRowVisibleInCashCounterTable = (bill) =>
    !!(bill?.services?.length > 0 || bill?.bill_type === "pharmacy" || bill?.bill_type === "ot" || bill?.bill_type === "RT");
const restrictPackageList = new Set(['Package Name', 'Assorted Package Name', 'Assorted Service Head', 'Service Name', 'Service Head']);
const isSamePackageObj = (a, b) =>
    (a?.package_id && a?.package_name && a?.package_id === b?.package_id && a?.package_name === b?.package_name) ||
    (a?.assorted_package_id && a?.assorted_package_name && a?.assorted_package_id === b?.assorted_package_id && a?.assorted_package_name === b?.assorted_package_name);

const togglePackageSelection = (list, order, checked, moduleIndex, orderIndex) => {
    return list.map((m, mi) => ({
        ...m,
        orders: m.orders.map((o, oi) => {

            const sameBillingType = o?.billing_display === order?.billing_display;

            const isSamePackage =
                restrictPackageList?.has(o?.billing_display) &&
                sameBillingType &&
                isSamePackageObj(order, o);

            // Package rows → update across modules
            if (isSamePackage) {
                return { ...o, selected: checked };
            }

            // Normal service row
            if (mi === moduleIndex && oi === orderIndex) {
                return { ...o, selected: checked };
            }

            return o;
        })
    }));
};

const CashCounter = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [cashCount, setCashCount] = useState({
        tlt_patient: 0, tlt_bills: 0, tlt_bill_amt: 0, tlt_credit_amt: 0, tlt_receipt_amt: 0, tlt_cash_amt: 0, tlt_card_amt: 0,
        tlt_upi_amt: 0, tlt_cancelled_bill: 0, tlt_refund_amt: 0, tlt_bank_amt: 0, tlt_cheque_amt: 0,
        searchPhoneUhid: '', searchIPOPNo: '', searchBillNo: '',
        patientSuggData: [], patient_details: {},
        pat_tlt_amt: 0, pat_tlt_paid: 0, pat_tlt_pending: 0, pat_bal_amt: 0,
        selectedRadio: props?.forReceivePayment ? 'advance' : 'settle', receivable_amt: null,
        isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
        cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
        upi_no: '', cheque_amt: '', cheque_no: '', page: 0, pageSize: 10,
        include_pharmacy: false,
        openReceipt: false, cash_collected: '', balance_amt: '', open: false, services: [], moduleType: "op",
        pharamacyList: [], AdmissionLists: [], selectedAdmission: null, getBillsFlag: false, card_details: null,
        advance_type: "advance", refund_type: "advance",
        from_refund_request: false, pharmaReturnData: {}, onlyPharmacyBill: false, patient_name: '', fromPharmacy: false,
        advCheck: false, advance_deducted: ''
    })
    const [postBtnDisble, setPostBtnDisble] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
    const [maxOutstandingAmount, setMaxOutshandingAmount] = useState(0)
    const [totalpaidAmount, setTotalPaidAmount] = useState(0)
    const [totalBillingAmount, setTotalBillingAmount] = useState(0)
    const [BillDetails, setBillDetails] = useState([])
    const [pharmaBillDetails, setPharmaBillDetails] = useState([])
    const [otBillDetails, setOtBillDetails] = useState([])
    const [duplicateBillDetails, setDuplicatetBillDetails] = useState([])
    const [PatientDetails, setPatientDetails] = useState({});
    const [ApproxCharges, setApproxCharges] = useState(0);
    let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    let autoFetchAmount = localGetItem('auto_fetch_bill_amount_to_payment')
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
    const [insuToolOpen, setInsuToolOpen] = useState(false);
    const [pharmacyAdv, setPharmacyAdv] = useState(0);
    const showPharmacy = loggedInUserInfo?.show_pharmacy_advance;
    const [fromRTmodule, setFromRTmodule] = useState(false);
    const [RtData, setRtData] = useState(null);
    const [RtAdvanceAdjected, setRtadvanceAdjected] = useState(0);
    const [ipOrderList, setIpOrdersList] = useState([])
    const [ipOrdertotalAmount, setIpOrdertotalAmount] = useState(0)
    const [RtsmsRemainderDate, setRTSmsRemainderDate] = useState(null)
    const [advAutoApplied, setAdvAutoApplied] = useState(false);
    const [isAdvAmountManual, setIsAdvAmountManual] = useState(false);
    const debounceRef = useRef(null);
    /** Bumps on each admission search; drop stale .then/.catch so an older patient_id response cannot toast/clear UI after a newer search started. */
    const admissionSearchSeqRef = useRef(0);
    const AutoAdvFetch = localGetItem("advance_auto_detect") === "true" ? true : false;

    useEffect(() => {
        if (props?.forReceivePayment) {
            if (getCachevalue("IppatientData")) {
                getPatientDataSearch(JSON.parse(getCachevalue("IppatientData"))?.patient_account_number)
                getPatientDetails(JSON.parse(getCachevalue("IppatientData"))?.id)
            }
        } else {
            getCollectionDetails()
            if (loggedInUserInfo?.module_name === 'front_office') {
                setCashCount((prev) => ({
                    ...prev,
                    pharamacyList: LoggedUserData?.pharmacy_data ? JSON.parse(JSON.stringify((LoggedUserData?.pharmacy_data))) : [],
                    include_pharmacy: showPharmacy ? false : LoggedUserData?.pharmacy_data ? JSON.parse(JSON.stringify((LoggedUserData?.pharmacy_data)))[0]?.pharmacy_id : true
                }))
            }
            if (location?.states?.module === "self") {
                getPatientDataSearch(location?.states?.patient_details?.patient_account_number)
            }
            if (location?.states?.FromRT) {
                setFromRTmodule(true)
                setRtData(location?.states?.RtWalkInDetails)
                if (location?.states?.RtWalkInDetails?.sms_reminder_date) {
                    if (new Date(location?.states?.RtWalkInDetails?.sms_reminder_date) >= new Date(new Date().setDate(new Date().getDate()))) {
                        setRTSmsRemainderDate(new Date(location?.states?.RtWalkInDetails?.sms_reminder_date))
                    }
                }
                setCashCount((prev) => ({
                    ...prev,
                    selectedRadio: "advance",
                }))
            }
        }
        localSetItem('from_cash_counter_edit', 'false');
    }, [])

    const getLastVisitDateOutstandingAmount = () => {
        try {
            let APIURL = `?appointment_id=${cashCount?.selectedAdmission?.appointment_id || ""}&admission_id=${cashCount?.selectedAdmission?.ip_admission_id || ""}&patient_id=${cashCount?.patient_details?.patient_id}&module=${cashCount?.selectedAdmission?.appointment_id ? "OP" : "IP"}&branch_id=${localGetItem("BranchId")}`
            RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + APIURL)
                .then((response) => {
                    if (response.data.status === "success") {
                        let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
                        let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
                        let AdvanceBalance = response.data?.advance_balance ? response.data.advance_balance : 0
                        let Obj = { "last_visited_date": Date, "total_outstanding": Amount, advance_balance: AdvanceBalance }
                        props.VisitDateBalAmount(Obj)
                    }
                    else {
                        errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    errorMessage(error.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    useEffect(() => {
        // Hide tooltip after 2 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(undefined);
        }, 2000);

        return () => {
            clearTimeout(hideTooltip);
        };
    }, [cashCount?.patient_details?.patient_id])

    useEffect(() => {
        if (location?.states?.patient_details && !location?.states?.from_refund_request && !location?.states?.FromRT) {
            if (location?.states?.from_op_list) {
                setCashCount((prev) => ({
                    ...prev,
                    moduleType: "op",
                    fromPharmacy: location?.states?.from_pharmacy ?? false
                }))
            } else if (location?.states?.from_ip_list) {
                setCashCount((prev) => ({
                    ...prev,
                    moduleType: "ip"
                }))
            } else if (location?.states?.from_pharmacy || location?.states?.from_pharma_bills_list) {
                setCashCount((prev) => ({
                    ...prev,
                    moduleType: location?.states?.module,
                    fromPharmacy: location?.states?.from_pharmacy ?? false
                }))
            }
            if (location?.states?.from_pharma_bills_list) {
                setBillDetails([])
                setPharmaBillDetails([])
                setOtBillDetails([])
                setDuplicatetBillDetails([])
                setMaxOutshandingAmount(0)
                setTotalPaidAmount(0)
                setTotalBillingAmount(0)
                setCashCount((prev) => ({
                    ...prev,
                    patient_details: {},
                    selectedAdmission: null,
                    getBillsFlag: false,
                    receivable_amt: null,
                    isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                    cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                    upi_no: '', cheque_amt: '', cheque_no: '',
                    services: [], AdmissionLists: [],
                }))
            }
            if ((location?.states?.from_pharma_bills_list && JSON.parse(localGetItem('enable_cash_counter_bill_modification')) && location?.states?.patient_details?.is_self) || location?.states?.self_patient) {
                getSelfPatientData(location?.states?.patient_details)
            } else if (location?.states?.from_pharma_bills_list && location?.states?.patient_details?.patient_id && !location?.states?.patient_details?.patient_account_number) {
                setCashCount((prev) => ({ ...prev, patient_details: location?.states?.patient_details }))
            } else {
                if (!location?.states?.self_patient) {
                    getPatientDataSearch(location?.states?.patient_details?.patient_account_number)
                }
            }
        }
        if (location?.states?.from_refund_request) {
            setCashCount((prev) => ({
                ...prev,
                from_refund_request: true,
                selectedRadio: "refund",
                patient_details: {},
                // receivable_amt: (location?.states?.refund_details?.net_amount || 0)
                receivable_amt: location?.states?.refund_details?.pharmacy_id ? (location?.states?.refund_details?.return_amount || 0) : (location?.states?.refund_details?.received_amount || 0),
            }))
            if (location?.states?.refund_details?.pharmacy_id) {
                getPharmacyRefundData(location?.states?.refund_details)
                setCashCount((prev) => ({ ...prev, onlyPharmacyBill: true, patient_name: location?.states?.refund_details?.patient_name }))
            }
        }
        if (location?.states?.FromRT) {
            setFromRTmodule(true)
            setRtData(location?.states?.RtWalkInDetails)
            if (location?.states?.RtWalkInDetails?.sms_reminder_date) {
                if (new Date(location?.states?.RtWalkInDetails?.sms_reminder_date) >= new Date(new Date().setDate(new Date().getDate()))) {
                    setRTSmsRemainderDate(new Date(location?.states?.RtWalkInDetails?.sms_reminder_date))
                }
            }
            setCashCount((prev) => ({
                ...prev,
                selectedRadio: "advance",
            }))
        } else {
            setFromRTmodule(false)
            setRtData(null)
        }
    }, [location?.states])

    useEffect(() => {
        if (cashCount?.patient_details?.patient_id && !props?.forReceivePayment && !cashCount?.from_refund_request && cashCount?.getBillsFlag && !location?.states?.FromRT) {
            getBillsData()
            if(loggedInUserInfo?.module_name === 'front_office'){
                getLastVisitDateOutstandingAmount()
            }
        }
    }, [cashCount?.getBillsFlag])

    useEffect(() => {
        if (cashCount?.patient_details?.patient_id && !props?.forReceivePayment && !cashCount?.from_refund_request && !location?.states?.FromRT) {
            if (location?.states?.module === "self") {
                getBillSearchData(location?.states?.search_value, true)
            } else {
                if (!location?.states?.from_pharma_bills_list || (location?.states?.from_pharma_bills_list && !location?.states?.patient_details?.is_self && !location?.states?.self_patient) || (location?.states?.from_pharma_home && !location?.states?.self_patient)) {
                    if (cashCount?.moduleType === "self") {
                        getBillsData(true)
                        if (loggedInUserInfo?.module_name === 'front_office') {
                            getLastVisitDateOutstandingAmount()
                        }
                    } else if (cashCount?.patient_details?.patient_id) {
                        getPatientDataAdmissionSearch(cashCount?.patient_details?.patient_id, location?.states?.patient_details?.op_number)
                    }
                }
            }
        }
    }, [cashCount?.patient_details?.patient_id, cashCount?.moduleType])

    useEffect(() => {
        setCashCount((prev) => ({
            ...prev,
            balance_amt: (+cashCount?.cash_collected && +cashCount?.cash_amt) ? (+cashCount?.cash_collected - +cashCount?.cash_amt) : ""
        }))
    }, [cashCount?.cash_collected, cashCount?.cash_amt])

    useEffect(() => {
        // if (duplicateBillDetails?.length) {
            setIntialBillDetails(duplicateBillDetails, true)
        // }
    }, [cashCount?.include_pharmacy])

    useEffect(() => {
        if (!cashCount?.from_refund_request && !location?.states?.FromRT) {
            setCashCount((prev) => ({
                ...prev,
                receivable_amt: null,
                isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                upi_no: '', cheque_amt: '', cheque_no: '',
            }))
        }
        if (location?.states?.FromRT) {
            let RTdetails = location?.states?.RtWalkInDetails
            calculateDeductables([
                {
                    ...RTdetails,
                    invoice_number: RTdetails?.invoice_number,
                    invoice_date: RTdetails?.invoice_date,
                    net_amount: RTdetails?.bill_amount,
                    outstanding_amount: RTdetails?.outstanding_amount,
                    bill_outstanding_amount: RTdetails?.outstanding_amount,
                    received_amount: RTdetails?.paid_amount,
                    bill_type: "RT",
                    bill_selected: true
                }
            ], true)
        }
        if (cashCount?.selectedRadio === "advance" && PatientDetails?.ip_admission_id && !PatientDetails?.is_final_bill_initiated && (cashCount?.moduleType === "ip" || (props?.forReceivePayment)) && localGetItem('ip_order_advance_adjust') === "true" && cashCount?.advance_type === "advance" && !location?.states?.FromRT && !cashCount?.from_refund_request && LoggedUserData?.module_name !== "Pharmacy") {
            getipOrdersList()
            setIpOrdertotalAmount(0)
        } else {
            setIpOrdersList([])
            setIpOrdertotalAmount(0)
        }
    }, [cashCount?.selectedRadio , cashCount?.advance_type, PatientDetails])

    useEffect(() => {
        if (!cashCount?.from_refund_request && !location?.states?.FromRT) {
            const total = ipOrderList.reduce((acc, module) => {
                const selectedOrdersTotal = module.orders.reduce((sum, order) => sum + (order.selected ? order.total_amount : 0), 0);
                return acc + selectedOrdersTotal;
            }, 0);
            setCashCount((prev) => ({
                ...prev,
                receivable_amt: total,
                isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                upi_no: '', cheque_amt: '', cheque_no: '',
            }))
            setIpOrdertotalAmount(total);
        }
    }, [ipOrderList]);



    useEffect(() => {
        if (postBtnDisble) {
            if (cashCount?.selectedRadio === 'settle') {
                if (window.location.pathname === '/PharmacyBilling/CashCounter') {
                    postPharmacyCashCounter()
                } else if (fromRTmodule) {
                    postRTAdvanceAmount(true)
                } else {
                    postCashCounter()
                }
            } else if (cashCount?.selectedRadio === 'advance') {
                if (cashCount?.advance_type === "advance") {
                    if (fromRTmodule) {
                        if (RtData?.bill_amount < (RtData?.advance_remaining + +cashCount?.receivable_amt)) {
                            errorMessage("Receivable amount is greater than bill amount")
                        } else {
                            postRTAdvanceAmount()
                        }
                    } else {
                        postAdvanceAmount()
                    }
                } else if (cashCount?.advance_type === "safety_deposit") {
                    postSafetyDepositAmount()
                }
            } else if (cashCount?.selectedRadio === 'refund') {
                if (cashCount?.from_refund_request) {
                    if (location?.states?.fromRTRefund) {
                        postRTAdvanceAmount(false, true)
                    } else {
                        postRefundAccept()
                    }
                } else if (cashCount?.refund_type === "advance") {
                    postAdvanceAmount()
                } else if (cashCount?.refund_type === "safety_deposit") {
                    postSafetyDepositAmount()
                }
            }
        }
    }, [postBtnDisble])

    useEffect(() => {
        const FetchingAccess = localGetItem("auto_fetch_bill_amount_to_payment");
        if (!cashCount.isCash) {
            setCashCount((prev) => ({
                ...prev,
                cash_amt: "",
                cash_collected: "",
                balance_amt: "",
            }));
        }
        if (!cashCount.isCard) {
            setCashCount((prev) => ({
                ...prev,
                card_amt: "",
                card_no: "",
            }));
        }
        if (!cashCount.isUPI) {
            setCashCount((prev) => ({
                ...prev,
                upi_amt: "",
                upi_no: "",
            }));
        }
        if (!cashCount.isCheque) {
            setCashCount((prev) => ({
                ...prev,
                cheque_amt: "",
                cheque_no: "",
            }));
        }
        if (!cashCount.isBank) {
            setCashCount((prev) => ({
                ...prev,
                bank_amt: "",
                bank_no: "",
            }));
        }
        if (FetchingAccess === "true") {
            setCashCount((prev) => ({
                ...prev,
                cash_amt: prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? (fromRTmodule ? ((+prev.receivable_amt) - RtAdvanceAdjected) : prev.receivable_amt) : prev.cash_amt,
                card_amt: !prev.isCash && prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? (fromRTmodule ? ((+prev.receivable_amt) - RtAdvanceAdjected) : prev.receivable_amt) : prev.card_amt,
                upi_amt: !prev.isCash && !prev.isCard && prev.isUPI && !prev.isBank && !prev.isCheque ? (fromRTmodule ? ((+prev.receivable_amt) - RtAdvanceAdjected) : prev.receivable_amt) : prev.upi_amt,
                bank_amt: !prev.isCash && !prev.isCard && !prev.isUPI && prev.isBank && !prev.isCheque ? (fromRTmodule ? ((+prev.receivable_amt) - RtAdvanceAdjected) : prev.receivable_amt) : prev.bank_amt,
                cheque_amt: !prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && prev.isCheque ? (fromRTmodule ? ((+prev.receivable_amt) - RtAdvanceAdjected) : prev.receivable_amt) : prev.cheque_amt,
            }));
        }
    }, [cashCount?.isCash, cashCount?.isCard, cashCount?.isUPI, cashCount?.isBank, cashCount?.isCheque]);

    useEffect(() => {
        if (props?.forReceivePayment || cashCount?.from_refund_request) return;

        if ((cashCount?.receivable_amt === "" && showPharmacy && cashCount?.advance_deducted === "") || (!showPharmacy && cashCount?.receivable_amt === "")) {
            setCashCount((prev) => ({
                ...prev,
                isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                upi_no: '', cheque_amt: '', cheque_no: '', cash_collected: '', balance_amt: '',
            }))
        }
        if (
            BillDetails?.length &&
            cashCount?.selectedRadio === 'settle' &&
            (cashCount?.receivable_amt !== null || (showPharmacy && cashCount?.advance_deducted !== null))
        ) {
            clearTimeout(debounceRef.current);

            debounceRef.current = setTimeout(() => {
                calculateDeductables();
            }, 500);
        }
        return () => clearTimeout(debounceRef.current);

    }, [cashCount?.receivable_amt, cashCount?.advance_deducted]);

    useEffect(() => {
        const adv = Number(pharmacyAdv) || 0;
        const outstanding = Number(maxOutstandingAmount) || 0;
        if (adv > 0 && !advAutoApplied && AutoAdvFetch && BillDetails?.length > 0 && outstanding > 0 && cashCount?.selectedRadio === 'settle') {
            setTimeout(() => {
                setCashCount(prev => ({
                    ...prev,
                    advCheck: true,
                    advance_deducted: prev.advance_deducted || Math.min(adv, outstanding)
                }));
                setAdvAutoApplied(true);
            }, 500);
        }
    }, [pharmacyAdv, advAutoApplied, BillDetails?.length, maxOutstandingAmount, cashCount?.selectedRadio]);

    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const [successPopup, setSuccessPopup] = useState({
        SuccessInvoice_ID: null,
        isCredit: false,
        bill_receipt_id: null,
        patiendId: null,
        successText: '',
        bill_module_type: ''
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
        setPostBtnDisble(false)
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
        setPostBtnDisble(false)
    }

    const LoaderFunction = (key) => {
        setIsLoader(key);
    };


    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const getPatientDetails = (id) => {
        try {
            RestAPIService.getAll(Serviceurls.IP_PATIENT_DETAILS_NEW + `?admission_id=${id}&clinic_id=${loginInfo?.clinic_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setPatientDetails(response?.data?.data[0] || null)
                        if (showPharmacy) {
                            setPharmacyAdv(response?.data?.data[0]?.pharmacy_advance_amount || 0)
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const setIntialBillDetails = (Data, ModuleCheck = false, pharmacyBills = pharmaBillDetails, Ot_bills = otBillDetails) => {
        try {
            let totalOutstandingAmount = 0;
            let totalPaidAmount = 0;
            let totalBillingAmount = 0;

            let updatedData = [];
            // Process main data
            for (let i = 0; i < Data.length; i++) {
                let bill = Data[i];
                let totalBillOutstanding = 0;
                let totalBillAmount = 0;
                let services = [];
                if (bill?.line_item) {
                    bill['bill_items'] = bill?.line_item
                }
                if (bill.bill_items) {
                    for (let j = 0; j < bill.bill_items.length; j++) {
                        let service = bill.bill_items[j];
                        // if (service?.outstanding_amount > 0) {
                        //     totalOutstandingAmount += service?.outstanding_amount;
                        //     totalPaidAmount += service?.received_amount;
                        //     totalBillingAmount += service?.net_amount;
                        //     totalBillOutstanding += service?.outstanding_amount;
                        //     totalBillAmount += service?.net_amount;
                        // }
                        services.push({
                            ...service,
                            bill_outstanding_amount: service?.outstanding_amount,
                            receipt_amount: 0,
                        });
                    }
                    totalOutstandingAmount += bill?.outstanding_amount;
                    totalPaidAmount += bill?.received_amount;
                    totalBillingAmount += bill?.net_amount;
                    totalBillOutstanding += bill?.outstanding_amount;
                    totalBillAmount += bill?.net_amount;
                }

                updatedData.push({
                    ...bill,
                    index: i,
                    // outstanding_amount: totalBillOutstanding,
                    New_outstanding_amount: bill?.outstanding_amount,
                    bill_amount: totalBillAmount,
                    receipt_amount: 0,
                    bill_selected: true,
                    services,
                });
            }

            // Process pharmacy bills
            let finalPharmacyBills = [];

            if ((cashCount?.include_pharmacy && localGetItem("Allow_Pharma_CreditBill_In_FO") === "true") || loggedInUserInfo?.module_name === 'Pharmacy') {
                if (cashCount?.pharamacyList?.length > 0) {
                    for (let i = 0; i < pharmacyBills.length; i++) {
                        if (pharmacyBills[i]?.pharmacy_id === cashCount.include_pharmacy) {
                            finalPharmacyBills.push({
                                ...pharmacyBills[i],
                                bill_outstanding_amount: pharmacyBills[i]?.outstanding_amount || 0,
                                index: updatedData.length + i,
                                receipt_amount: 0,
                                bill_amount: pharmacyBills[i]?.net_amount || 0,
                                bill_selected: true,
                                bill_type: "pharmacy"
                            });
                            totalOutstandingAmount += pharmacyBills[i]?.outstanding_amount;
                            totalBillingAmount += pharmacyBills[i]?.net_amount;
                            totalPaidAmount += pharmacyBills[i]?.received_amount;
                        }
                    }
                } else {
                    for (let i = 0; i < pharmacyBills.length; i++) {
                        finalPharmacyBills.push({
                            ...pharmacyBills[i],
                            index: updatedData.length + i,
                            receipt_amount: 0,
                            bill_amount: pharmacyBills[i]?.net_amount || 0,
                            bill_outstanding_amount: pharmacyBills[i]?.outstanding_amount || 0,
                            bill_selected: true,
                            bill_type: "pharmacy"
                        });
                        totalOutstandingAmount += pharmacyBills[i]?.outstanding_amount;
                        totalBillingAmount += pharmacyBills[i]?.net_amount;
                        totalPaidAmount += pharmacyBills[i]?.received_amount;
                    }
                }
                updatedData.push(...finalPharmacyBills);
            };

            // Process ot bills
            if (Ot_bills?.length) {
                let finalOtBills = [];
                for (let i = 0; i < Ot_bills.length; i++) {
                    finalOtBills.push({
                        ...Ot_bills[i],
                        index: updatedData.length + i,
                        receipt_amount: 0,
                        bill_amount: Ot_bills[i]?.total_net_amount || 0,
                        bill_outstanding_amount: Ot_bills[i]?.outstanding_amount || 0,
                        bill_selected: true,
                        bill_type: "ot"
                    });
                    totalOutstandingAmount += Ot_bills[i]?.outstanding_amount;
                    totalBillingAmount += Ot_bills[i]?.total_net_amount;
                    totalPaidAmount += Ot_bills[i]?.received_amount;
                }
                updatedData.push(...finalOtBills);
            };

            // Update state
            setBillDetails(updatedData || []);
            setMaxOutshandingAmount(totalOutstandingAmount);
            setTotalPaidAmount(totalPaidAmount);
            setTotalBillingAmount(totalBillingAmount);
            setCashCount((prev) => ({ ...prev, getBillsFlag: false }));
            if (ModuleCheck) {
                setCashCount((prev) => ({ ...prev, receivable_amt: "" }));
            }
        }
        catch (error) {
            errorMessage(error?.message)
        }
    }

    const getPharmacyRefundData = (item) => {
        try {
            RestAPIService.getAll(Serviceurls.PHARMA_BILLS_GET + "?id=" + item?.bill_summary_id + '&request_id=' + item?.request_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setCashCount((prev) => ({ ...prev, pharmaReturnData: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const calculateDeductables = (BillData = BillDetails, BillCheck = false, Manuall) => {
        try {
            let remainingAmount = (parseFloat(cashCount?.receivable_amt) || 0) || 0;
            let remainingAdvance = (parseFloat(cashCount?.advance_deducted) || 0) || 0;

            let totalOutstandingAmount = 0;
            let totalPaidAmount = 0;
            let totalBillingAmount = 0;
            let totalAdvanceDeducted = 0;

            let updatedList = [];

            const hasAnySelected = BillData?.some(bill => bill?.bill_selected);

            if (!hasAnySelected && AutoAdvFetch) {
                setCashCount(prev => ({
                    ...prev,
                    advCheck: false,
                    advance_deducted: ""
                }));
            }

            for (let i = 0; i < BillData.length; i++) {
                let bill = BillData[i];

                if (!bill.bill_selected) {
                    let updatedServices = bill.services ? bill.services.map(service => ({
                        ...service,
                        receipt_amount: 0,
                        outstanding_amount: 0,
                    })) : [];

                    updatedList.push({
                        ...bill,
                        services: updatedServices,
                        receipt_amount: 0,
                        outstanding_amount: 0,
                        advance_deducted_amount: 0,
                    });
                    continue;
                }

                let updatedServices = [];
                let outstandingSum = 0;
                let receiptSum = 0;

                if (bill.bill_type === "pharmacy") {
                    // advance deduction for pharmacy bills
                    let advanceDeduct = Math.min(bill.bill_outstanding_amount || 0, remainingAdvance);
                    remainingAdvance -= advanceDeduct;
                    totalAdvanceDeducted += advanceDeduct;
                    // Deduct pharmacy bills as a whole (bill-wise)
                    let billDeduct = Math.min(bill.bill_outstanding_amount - advanceDeduct, remainingAmount);
                    remainingAmount -= billDeduct;

                    updatedList.push({
                        ...bill,
                        receipt_amount: +(advanceDeduct + billDeduct).toFixed(2),
                        advance_deducted_amount: +advanceDeduct.toFixed(2),
                        outstanding_amount: bill.bill_outstanding_amount,
                        bill_selected: true,
                    });
                    totalOutstandingAmount += bill.bill_outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;
                    if (((cashCount?.advCheck && !isAdvAmountManual) || (cashCount?.advCheck && Manuall)) && AutoAdvFetch) {
                        const adv = Number(pharmacyAdv) || 0;
                        const outstanding = Number(totalOutstandingAmount) || 0;
                            setCashCount(prev => ({
                                ...prev,
                                advance_deducted: Math.min(adv, outstanding)
                            }));
                    }
                } else if (bill.bill_type === "ot" || bill.bill_type === "RT") {
                    // Deduct pharmacy bills as a whole (bill-wise)
                    let billDeduct = Math.min(bill.bill_outstanding_amount, remainingAmount);
                    remainingAmount -= billDeduct;

                    updatedList.push({
                        ...bill,
                        receipt_amount: +billDeduct.toFixed(2),
                        outstanding_amount: bill.bill_outstanding_amount,
                        bill_selected: true,
                    });
                    totalOutstandingAmount += bill.bill_outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;

                } else {
                    // Deduct other bills service-wise
                    if (bill.services) {
                        let tempRemainingAmt = remainingAmount
                        for (let j = 0; j < bill.services.length; j++) {
                            let service = bill.services[j];
                            let deduct = 0;
                            if (tempRemainingAmt > 0) {
                                deduct = Math.min(service.bill_outstanding_amount || 0, tempRemainingAmt);
                                tempRemainingAmt -= deduct;
                            }

                            let updatedService = {
                                ...service,
                                receipt_amount: +deduct.toFixed(2),
                                outstanding_amount: service.bill_outstanding_amount || 0,
                            };

                            updatedServices.push(updatedService);
                            receiptSum += updatedService.receipt_amount;
                        }
                        outstandingSum = BillData[i].New_outstanding_amount
                    }
                    let deduct = 0;
                    if (remainingAmount > 0) {
                        deduct = Math.min(bill.outstanding_amount || 0, remainingAmount);
                        remainingAmount -= deduct;
                    }
                    totalOutstandingAmount += BillData[i].New_outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;

                    updatedList.push({
                        ...bill,
                        services: updatedServices,
                        outstanding_amount: outstandingSum,
                        receipt_amount: deduct,
                    });
                }
            }

            setBillDetails(updatedList);
            setMaxOutshandingAmount(totalOutstandingAmount);
            setTotalPaidAmount(totalPaidAmount);
            setTotalBillingAmount(totalBillingAmount);

            if (BillCheck) {
                setCashCount((prev) => ({ ...prev, receivable_amt: "" }));
            }
        }
        catch (error) {
            errorMessage(error?.message)
        }
    };

    const handlePaymentAutoFill = useCallback((key, value = "") => {
        const payable = +cashCount?.receivable_amt || 0;

        let updated = {
            cash_amt: cashCount.cash_amt || "",
            card_amt: cashCount.card_amt || "",
            upi_amt: cashCount.upi_amt || "",
            bank_amt: cashCount.bank_amt || "",
            cheque_amt: cashCount.cheque_amt || "",
        };

        const paymentFlow = [
            { key: "cash_amt", enabled: cashCount.isCash },
            { key: "card_amt", enabled: cashCount.isCard },
            { key: "upi_amt", enabled: cashCount.isUPI },
            { key: "bank_amt", enabled: cashCount.isBank },
            { key: "cheque_amt", enabled: cashCount.isCheque },
        ];

        const currentIndex = paymentFlow.findIndex(p => p.key === key);

        const totalExisting = Object.values(updated).reduce((sum, val) => sum + (+val || 0), 0);

        if (totalExisting === 0 && paymentFlow[currentIndex]?.enabled) {
            const cleared = Object.fromEntries(
                Object.keys(updated).map(k => [k, ""])
            );

            cleared[key] = payable;

            setCashCount(prev => ({ ...prev, ...cleared }));
            return;
        }

        updated[key] = +value || "";

        let cumulativeTotal = 0;
        let nextFilled = false;

        for (let i = 0; i < paymentFlow.length; i++) {
            const modeKey = paymentFlow[i].key;

            if (i <= currentIndex) {
                cumulativeTotal += +updated[modeKey] || 0;
            } else {
                updated[modeKey] = ""; // reset next modes
            }
        }

        const balance = payable - cumulativeTotal;
        if (balance < 0) return;

        for (let i = currentIndex + 1; i < paymentFlow.length && !nextFilled; i++) {
            if (paymentFlow[i].enabled) {
                updated[paymentFlow[i].key] = balance;
                nextFilled = true;
            }
        }

        setCashCount(prev => ({ ...prev, ...updated }));

    }, [
        cashCount?.cash_amt,
        cashCount?.card_amt,
        cashCount?.upi_amt,
        cashCount?.bank_amt,
        cashCount?.cheque_amt,
        cashCount?.isCash,
        cashCount?.isCard,
        cashCount?.isUPI,
        cashCount?.isBank,
        cashCount?.isCheque,
        cashCount?.receivable_amt
    ]);

    const onChangeHandler = (e, key) => {
        try {
            let value = e.target.value
            let MaxAmount = ""
            if (cashCount?.selectedRadio === "settle") {
                MaxAmount = JSON.parse(JSON.stringify(maxOutstandingAmount))
            } else if (cashCount?.selectedRadio === "refund") {
                if (cashCount?.refund_type === "safety_deposit") {
                    MaxAmount = (+PatientDetails?.safety_deposit_amount || 0)
                } else {
                    MaxAmount = showPharmacy && loginInfo?.module_name === "Pharmacy" ? (+PatientDetails?.pharmacy_advance_amount || 0) : (+PatientDetails?.advance_amount || 0)
                }
            } else if (cashCount?.from_refund_request) {
                MaxAmount = (location?.states?.refund_details?.net_amount || 0)
            }

            setCashCount((prev) => {
                switch (key) {
                    case 'cash_amt':
                    case 'card_amt':
                    case 'upi_amt':
                    case 'bank_amt':
                    case 'cheque_amt':
                        if (value === '' || (CommonValidation.numberOnly(value)) && (+cashCount?.receivable_amt >= parseFloat(value))) {
                            const FetchingAccess = localGetItem("auto_fetch_bill_amount_to_payment")
                            if (FetchingAccess && FetchingAccess === "true") {
                                handlePaymentAutoFill(key, value)
                            }
                            return { ...prev, [key]: value }
                        } else {
                            return { ...prev }
                        }
                    case 'receivable_amt':
                        if (value === '' || (CommonValidation.numberOnly(value)) && ((MaxAmount >= parseFloat(value) + (+cashCount?.advance_deducted || 0)) || (cashCount?.selectedRadio === 'advance') || (props?.forReceivePayment && cashCount?.selectedRadio !== 'refund'))) {
                            if (fromRTmodule && value && cashCount?.selectedRadio === "settle") {
                                setRtadvanceAdjected((RtData?.advance_remaining >= +value) ? +value : RtData?.advance_remaining)
                            }
                            return { ...prev, [key]: value }
                        } else {
                            return { ...prev }
                        }
                    default:
                        return { ...prev, [key]: value }
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientDataSearch = (searchKey = "") => {
        try {
            const OpNumber = cashCount?.patient_details?.patient_id ?  cashCount?.patient_details?.patient_id  : location?.states?.patient_details?.op_number
            LoaderFunction(true);
            RestAPIService
                .getAll(Serviceurls.CASH_COUNTER_PATIENT_SEARCH + '?search_key=' + encodeURIComponent(searchKey) + '&module=' + (OpNumber ? "op" : (location?.states?.module ? location?.states?.module : cashCount?.moduleType)))
                .then((response) => {
                    if (response.data.status === 'success') {
                        const list = response.data.data || [];
                        LoaderFunction(false);
                        if (list?.length) {
                            const fromPharmaHomeBack = location?.states?.from_pharma_bills_list || (location?.states?.from_pharmacy && location?.states?.patient_details);
                            let data = list[0];
                            let suggData = [];
                            if (list?.length > 1) {
                                if (fromPharmaHomeBack && searchKey) {
                                    const matched = list?.find((item) => String(item?.patient_account_number || '') === String(searchKey));
                                    if (matched) {
                                        data = matched;
                                        suggData = [];
                                    } else {
                                        data = {};
                                        suggData = list;
                                    }
                                } else {
                                    data = {};
                                    suggData = list;
                                }
                            }
                            setCashCount((prev) => ({
                                ...prev,
                                patient_details: data,
                                searchPhoneUhid: "",
                                searchIPOPNo: "",
                                patientSuggData: suggData,
                                moduleType: ((location?.states?.module === 'pharmacy' && loginInfo?.module_name === 'Pharmacy') ? 'self' : (location?.states?.module ? location?.states?.module : prev?.moduleType)),
                                from_refund_request: false,
                                selectedRadio: props?.forReceivePayment ? 'advance' : 'settle',
                                receivable_amt: null,
                                fromPharmacy: loginInfo?.module_name === 'Pharmacy' ? true : false
                            }))
                            setInsuToolOpen(true);
                        } else {
                            setBillDetails([]);
                            setMaxOutshandingAmount(0);
                            setTotalPaidAmount(0);
                            setTotalBillingAmount(0)
                            if (!location?.states?.from_pharma_home) {
                                errorMessage("No Records Found !");
                            }
                        }
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getSelfPatientData = (searchKey) => {
        try {
            LoaderFunction(true);
            RestAPIService
                .getAll(Serviceurls.PHARMA_SELF_PATIENT_CREDIT + `?name=${searchKey?.patient_name}&mobile=${searchKey?.patient_mobile_number}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const list = response.data.data || [];
                        LoaderFunction(false);
                        if (list?.length) {
                            setCashCount((prev) => ({
                                ...prev,
                                from_refund_request: false,
                                selectedRadio: props?.forReceivePayment ? 'advance' : 'settle',
                                receivable_amt: null,
                                fromPharmacy: loginInfo?.module_name === 'Pharmacy' ? true : false,
                                suggData: list,
                                patient_details: list[0],
                                moduleType: ((location?.states?.module === 'pharmacy' && loginInfo?.module_name === 'Pharmacy') ? 'self' : (location?.states?.module ? location?.states?.module : prev?.moduleType)),
                            }))
                            setPharmaBillDetails(list || [])
                            setIntialBillDetails([], false, (list || []), [])
                            setInsuToolOpen(true);
                        } else {
                            setBillDetails([]);
                            setMaxOutshandingAmount(0);
                            setTotalPaidAmount(0);
                            setTotalBillingAmount(0)
                            if (!location?.states?.from_pharma_home) {
                                errorMessage("No Records Found !");
                            }
                        }
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getBillSearchData = (searchKey = "", HaveData = false) => {
        try {
            LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_BILL_SEARCH + '?search_key=' + encodeURIComponent(searchKey))
                .then((response) => {
                    if (response.data.status === 'success') {
                        LoaderFunction(false)
                        if (response?.data?.dept === "ph") {
                            setPharmaBillDetails(response.data.data || [])
                            setIntialBillDetails([], false, (response?.data?.data || []), [])
                        } else if (response?.data?.dept === "ot") {
                            setIntialBillDetails([], false, [], (response?.data?.data || []))
                        } else {
                            setIntialBillDetails((response?.data?.data || []))
                        }
                        if (response?.data?.data?.length) {
                            setCashCount((prev) => ({
                                ...prev, searchBillNo: ""
                            }))
                            if (location?.states?.module !== "self") {
                                getPatientDataSearch(response?.data?.data[0]?.uhid || "")
                            }
                        }
                    } else {
                        LoaderFunction(false);
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getCollectionDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_COLLECTION_CARD)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let CardDetails = response?.data?.data || null
                        setCashCount((prev) => ({
                            ...prev,
                            tlt_patient: CardDetails?.total_patient || 0,
                            tlt_bills: CardDetails?.total_bills || 0,
                            tlt_bill_amt: CardDetails?.total_bill_amount || 0,
                            tlt_credit_amt: CardDetails?.total_credit_amount || 0,
                            tlt_cancelled_bill: CardDetails?.total_cancel_bills || 0,
                            tlt_refund_amt: CardDetails?.total_refund_amount || 0,
                            tlt_receipt_amt: CardDetails?.total_receipt_amount || 0,
                            tlt_cash_amt: CardDetails?.cash_amount || 0,
                            tlt_card_amt: CardDetails?.card_amount || 0,
                            tlt_upi_amt: CardDetails?.upi_amount || 0,
                            tlt_bank_amt: CardDetails?.bank_amount || 0,
                            tlt_cheque_amt: CardDetails?.cheque_amount || 0,
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getBillsData = (FromSelf = false) => {
        try {
            LoaderFunction(true);
            let QueryParams = ""
            if (FromSelf) {
                QueryParams = `?patient_id=${cashCount?.patient_details?.patient_id}`
            } else {
                QueryParams = `?appointment_id=${cashCount?.selectedAdmission?.appointment_id || ""}&ip_admission_id=${cashCount?.selectedAdmission?.ip_admission_id || ""}&patient_id=${cashCount?.patient_details?.patient_id}`
            }
            const fromPharmacyParam = cashCount?.fromPharmacy ? "&from_pharmacy=true" : "&from_pharmacy=false"
            const moveToCashCounterParam = location?.states?.from_pharma_bills_list ? "&move_to_cash_counter=true" : "&move_to_cash_counter=false"
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_BILLS_GET + QueryParams + fromPharmacyParam + moveToCashCounterParam)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const list = response.data.data?.bills || [];
                        LoaderFunction(false);
                        // if (list?.length) {
                        setIntialBillDetails(list, false, (response.data.data?.ph_bills || []), (response.data.data?.ot_bills || []))
                        setPharmaBillDetails(response.data.data?.ph_bills || [])
                        setOtBillDetails(response.data.data?.ot_bills || [])
                        setDuplicatetBillDetails(list)
                        setCashCount((prev) => ({ ...prev, fromPharmacy: false }))
                        // } else {
                        //     errorMessage("No Records Found !");
                        // }
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };
    const getPatientDataAdmissionSearch = (patientId = null, OpNumber = null) => {
        try {
            const requestSeq = ++admissionSearchSeqRef.current;
            LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_MODULE_SEARCH + '?patient_id=' + patientId + "&module=" + (OpNumber ? "op" : (location?.states?.module ? location?.states?.module : cashCount?.moduleType)))
                .then((response) => {
                    if (requestSeq !== admissionSearchSeqRef.current) {
                        return;
                    }
                    if (response.data.status === 'success') {
                        const list = response.data.data || [];
                        LoaderFunction(false);
                        if (list?.length) {
                            // const lastIndex = list.length - 1
                            let data = list?.length > 0 ? list[0] : null
                            if (location?.states?.search_label && location?.states?.search_value) {
                                if (String(location?.states?.search_value)?.includes("OT/")) {
                                    // For OT - no need to change data
                                } else {
                                    data = list?.find((item) => (item[location?.states?.search_label] === location?.states?.search_value))
                                }
                            } else if (OpNumber) {
                                data = list?.find((item) => (item?.op_number === OpNumber))
                            }

                            setCashCount((prev) => ({
                                ...prev,
                                moduleType: OpNumber ? "op" : (location?.states?.module ? location?.states?.module : prev?.moduleType),
                                openAdmissionMenu: list?.length ? true : false,
                                searchIPOPNo: "",
                                AdmissionLists: list,
                                selectedAdmission: data,
                                getBillsFlag: (cashCount?.selectedRadio === 'settle' && (location.states?.from_op_list || data !== null)) ? !prev.getBillsFlag : prev.getBillsFlag,
                                opNumber: data?.op_number || "",
                            }))
                            if (cashCount?.moduleType === "ip" && data && data?.ip_admission_id) {
                                getPatientDetails(data?.ip_admission_id)
                            }
                        } else {
                            setBillDetails([]);
                            setMaxOutshandingAmount(0);
                            setTotalPaidAmount(0);
                            setTotalBillingAmount(0)
                            setCashCount((prev) => ({
                                ...prev,
                                AdmissionLists: [],
                                selectedAdmission: null,
                            }))
                            if (!location?.states?.from_pharma_home) {
                                errorMessage("No Pending Bills for this patient !");
                            }
                        }
                    }
                }).catch((error) => {
                    if (requestSeq !== admissionSearchSeqRef.current) {
                        return;
                    }
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };
    const getipOrdersList = () => {
        try {
            LoaderFunction(true);
            let fromModule = LoggedUserData?.module_name
            RestAPIService.getAll(Serviceurls.GET_IP_ORDERS_FOR_ADJUST + '?ip_admission_id=' + (props?.forReceivePayment ? JSON.parse(getCachevalue("IppatientData"))?.id : cashCount?.selectedAdmission?.ip_admission_id) + "&module_type=" + fromModule)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setIpOrdersList(response?.data?.data || [])
                        setIpOrdertotalAmount(0)
                        LoaderFunction(false);
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const PatientSelectionPopup = () => {
        return (
            <Modal open={cashCount?.patientSuggData?.length > 0}>
                <Box className="eMed_MobileNum_Main" width={"31.5vw"}>
                    <Box component={'div'} className="eMed_MobileNum_Header">
                        <Typography variant='h6'>{"Patient List"}</Typography>
                        <IconButton onClick={() => {
                            setCashCount((prev) => ({
                                ...prev,
                                patientSuggData: []
                            }))
                        }} marginRight={'4vw'}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </IconButton>
                    </Box>
                    <Box component={'div'} className="eMed_MobileNum_wrapper" width={"31vw"}>
                        {cashCount?.patientSuggData?.length > 0 && cashCount?.patientSuggData.map((list) => {
                            let patientFullName = `${list.first_name} ${list.last_name}`;
                            const patientData = {
                                ...list,
                                patient_name: patientFullName,
                                patient_mobile_number: list.mobile_number,
                                patient_photo_url: list.photo_url
                            };

                            return (
                                <Box key={list.patient_account_number}>
                                    <Box className="eMed_Patient_Num_Search_pop" sx={{ width: "30vw" }}>
                                        <CommonPatientDetails data={patientData} hideInsurance={true} />
                                        <Button
                                            size='small'
                                            variant='contained'
                                            sx={{ textTransform: 'capitalize' }}
                                            onClick={() => {
                                                setCashCount((prev) => ({
                                                    ...prev,
                                                    patientSuggData: [],
                                                    patient_details: list,
                                                }))
                                            }}
                                        >
                                            Proceed
                                        </Button>
                                    </Box>
                                    <Divider />
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Modal>
        );
    };

    const textBox = (key, values, labels, width, disable = false) => {
        return (
            key === "searchIPOPNo" ?
                <Autocomplete
                    size={'small'}
                    options={cashCount?.AdmissionLists}
                    disabled={disable}
                    getOptionLabel={(option) => (option?.ip_number ? `${option?.ip_number}` : option?.op_number ? `${option?.op_number}` : "")}
                    value={cashCount?.selectedAdmission || null}
                    onChange={(event, newValue) => {
                        // setCashCount((prev) => ({
                        //     ...prev,
                        //     selectedAdmission: newValue
                        // }))
                        // getPatientDetails(data?.ip_admission_id)
                        setCashCount((prev) => {
                            let value = { ...prev, selectedAdmission: newValue, getBillsFlag: !prev?.getBillsFlag }
                            if (cashCount?.moduleType === 'ip' && newValue) {
                                getPatientDetails(newValue?.ip_admission_id)
                            }
                            return value
                        })

                    }}
                    clearIcon={false}
                    renderInput={(params) => <TextField {...params} label={labels} disabled={disable} sx={{ mt: '0.7rem', width: width, mr: "1vw", visibility: (props?.forReceivePayment || fromRTmodule || cashCount?.from_refund_request) ? 'hidden' : "visible" }}
                    />}
                />
                :
                <TextField
                    size='small'
                    fullWidth
                    // InputProps={{ style: { height: '4.5dvh' }, emed_tid: key }}
                    InputProps={{ emed_tid: key }}
                    sx={{ mt: '0.7rem', width: width, mr: (key === "searchPhoneUhid" || key === "searchIPOPNo" || key === "searchBillNo") ? "1vw" : null, visibility: ((props?.forReceivePayment || fromRTmodule || cashCount?.from_refund_request) && (key === "searchPhoneUhid" || key === "searchIPOPNo" || key === "searchBillNo")) ? 'hidden' : "visible" }}
                    value={values || ""}
                    onChange={(e) => onChangeHandler(e, key)}
                    label={labels}
                    disabled={disable}
                    autoComplete='off'
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4 && key === "searchPhoneUhid") {
                            getPatientDataSearch(e.target.value, "")
                        }
                        if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4 && key === "searchBillNo") {
                            getBillSearchData(e.target.value, false)
                        }
                    }}
                />
        )
    }

    const cashTextBox = (key, values, label, Icon) => {
        return (
            <TextField
                size='small'
                sx={{ width: '10dvw', mt: '0.5rem' }}
                value={values}
                label={`${label} (${CurrencySymbol})`}
                onChange={(e) => onChangeHandler(e, key)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    )
                }}
            />
        )
    }

    const referenceTextBox = (key, values) => {
        return (
            <TextField
                size='small'
                sx={{ width: '13dvw', mt: '0.5rem', ml: '0.5rem' }}
                value={values}
                label={'Reference Number'}
                onChange={(e) => onChangeHandler(e, key)}
                InputProps={{ emed_tid: key }}
            />
        )
    }

    const handleCheckBox = (e, key) => {
        try {
            let checked = e.target.checked
            setCashCount((prev) => ({ ...prev, [key]: checked }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPatientCard = (item, showNumber) => {
        try {
            const namePart = `${item?.first_name || ''} ${item?.last_name || ''}`.trim()
            const ageGenderPart = (item?.age || item?.patient_age) ? `${item?.age || item?.patient_age}/${genderMap[item?.gender] || '-'}` : ''
            let patientName = [namePart, ageGenderPart].filter(Boolean).join(' ') || '-'
            let uhidMob = `${item?.patient_account_number || '-'} | ${item?.mobile_number || '-'}`
            let ioOpNumber = item?.op_number ? `OP Patient No.:${item?.op_number}` : item?.ip_number ? `IP Patient No.:${item?.ip_number}` : 'Patient No.'
            return (
                <Box component={'div'}>
                    <Box component={'div'} borderBottom={showNumber ? '1px solid lightgray' : 'none'}>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            <Box component={'div'} mr={'0.5rem'}>
                                <Box component={'img'} src={ImagePaths.Male.default} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${ // Specify border width, style, and color
                                    (item?.patient_type === "new_patient" || item?.patient_type === 1)
                                        ? "#F1584A"
                                        : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient_type === 3)
                                            ? "#800080"
                                            : '#29B6F6'
                                    }`} />
                            </Box>
                            <Box component={'div'}>
                                {patientName ? patientName?.length > 25 ?
                                    <Tooltip><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, 25) + '...'}{renderInsCorpDetails(props?.forReceivePayment ? PatientDetails : { ...item, ...PatientDetails }, insuToolOpen)}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}{renderInsCorpDetails(props?.forReceivePayment ? PatientDetails : { ...item, ...PatientDetails }, insuToolOpen)}</Typography> : '-'}
                                {uhidMob ? uhidMob?.length > 30 ?
                                    <Tooltip><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                            </Box>
                        </Box>
                    </Box>
                    {showNumber ?
                        <Box component={'div'} mt={'0.5rem'}>
                            {ioOpNumber ? ioOpNumber?.length > 30 ?
                                <Tooltip><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{ioOpNumber?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{ioOpNumber}</Typography> : '-'}
                        </Box> : null}
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderGridOne = () => {
        try {
            return (
                <Box component={'div'} >
                    <Box component={'div'} p={'0.5rem'} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', height: "7.5dvh", width: "77.5dvw" }}>
                        {fromRTmodule ?
                            <Box component={'div'} width={'15dvw'}>
                                {RtData ? <CommonPatientDetails data={RtData} /> : null}
                            </Box>
                            :
                            <>
                                <FormControl sx={{ width: '7dvw', mr: "1vw", visibility: (props?.forReceivePayment || fromRTmodule || cashCount?.from_refund_request) ? 'hidden' : "visible" }} size='small'>
                                    <InputLabel>Module</InputLabel>
                                    <Select
                                        label='Module'
                                        value={cashCount.moduleType}
                                        disabled={(location?.states?.search_label && location?.states?.search_value) || Object.keys(cashCount.patient_details)?.length > 0}
                                        onChange={(e) => {
                                            setCashCount((prev) => ({ ...prev, moduleType: e.target.value }))
                                        }}
                                    >
                                        <MenuItem value={'op'}>OP</MenuItem>
                                        <MenuItem value={'ip'}>IP</MenuItem>
                                        <MenuItem value={'self'}>Self</MenuItem>
                                    </Select>
                                </FormControl>
                                {textBox('searchPhoneUhid', cashCount.searchPhoneUhid, 'Search UHID/Phone No.', '18dvw', ((location?.states?.search_label && location?.states?.search_value) || (Object.keys(cashCount.patient_details)?.length > 0)))}
                                {textBox('searchIPOPNo', cashCount.searchIPOPNo, 'Search OP/IP No.', '18dvw', ((location?.states?.search_label && location?.states?.search_value) || (Object.keys(cashCount.patient_details ? cashCount.patient_details : {})?.length === 0)))}
                                {textBox('searchBillNo', cashCount.searchBillNo, 'Search Bill No.', '18dvw', (location?.states?.search_label && location?.states?.search_value))}
                                <Box component={'div'} width={'15dvw'}>
                                    {Object.keys(cashCount.patient_details)?.length > 0 ? renderPatientCard(cashCount.patient_details, false) : null}
                                </Box>
                            </>}
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handleCheckChange = (index) => {
        let BillData = BillDetails?.map((row) =>
            row.index === index ? {
                ...row,
                bill_selected: !row.bill_selected,
            } : row
        )
        calculateDeductables(BillData, true, true)
    };

    const visibleBillsInTable = useMemo(
        () => (BillDetails || []).filter(billRowVisibleInCashCounterTable),
        [BillDetails]
    );
    const allBillsSelected = visibleBillsInTable.length > 0 && visibleBillsInTable.every((b) => b.bill_selected);
    const someBillsSelected = visibleBillsInTable.some((b) => b.bill_selected);

    const handleSelectAllVisibleBills = useCallback(() => {
        const allOn = visibleBillsInTable.length > 0 && visibleBillsInTable.every((b) => b.bill_selected);
        const selectAll = !allOn;
        const updatedBillsSelection = (BillDetails || []).map((bill) => {
            if (!billRowVisibleInCashCounterTable(bill)) return bill;
            return {
                ...bill,
                bill_selected: selectAll,
                discount_amount: '',
                general_discount_percentage: "",
            };
        });
        calculateDeductables(updatedBillsSelection, true, true)
    }, [BillDetails, visibleBillsInTable]);

    const renderGridTwo = () => {
        try {
            return (
                <Box component={'div'} borderTop={'1px solid lightgray'}>
                    <Box component={'div'} p={'0.5rem'} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '5dvh' }}>
                        <Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>{cashCount?.selectedRadio === 'advance' && ipOrderList?.length ? "Order Details" : "Bill Details"}</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} visibility={(props?.forReceivePayment || fromRTmodule || cashCount?.from_refund_request || cashCount?.selectedRadio !== "settle" || localGetItem("Allow_Pharma_CreditBill_In_FO") === "false") ? 'hidden' : "visible"}>
                            {showPharmacy && loggedInUserInfo?.module_name !== 'Pharmacy' && cashCount?.pharamacyList?.length > 0 ? <Tooltip title={'Pharmacy bills cannot be completed in the Front Office. Please proceed in Pharmacy.'} placement='top'><IconButton size='small' sx={{ marginRight: "0.75vw" }}><img src={ImagePaths.InfoFill.default} style={{ width: '.9vw', height: '.9vw' }} alt='copy' /></IconButton></Tooltip> : null}
                            {LoggedUserData?.module_name === 'Pharmacy' ? null :
                                cashCount?.pharamacyList?.length > 0 ?
                                    cashCount?.pharamacyList?.map((item) => (
                                        <FormControlLabel key = {item?.pharmacy_id} control={<Checkbox disabled={showPharmacy} size='small' checked={item?.pharmacy_id === cashCount.include_pharmacy} onChange={(e) => {
                                            setCashCount((prev) => ({ ...prev, include_pharmacy: cashCount?.include_pharmacy === item?.pharmacy_id ? null : item?.pharmacy_id }))
                                        }} />} label={`${item?.pharmacy_name}`} />
                                    ))
                                    : <FormControlLabel control={<Checkbox disabled={showPharmacy} size='small' checked={cashCount.include_pharmacy} onChange={(e) => {
                                        setCashCount((prev) => ({ ...prev, include_pharmacy: !cashCount?.include_pharmacy }))
                                    }} />} label="Include Pharmacy Bills" />}
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                            <RadioGroup
                                row
                                value={cashCount.selectedRadio}
                                onChange={(e) => {
                                    setCashCount((prev) => ({
                                        ...prev,
                                        selectedRadio: e.target.value,
                                        advCheck: false, advance_deducted: ''
                                    }))
                                }}
                            >
                                {(cashCount?.from_refund_request || (!props?.fromFo && ((loggedInUserInfo?.module_name !== 'Pharmacy') || (loggedInUserInfo?.module_name === 'Pharmacy' && !showPharmacy)))) ? null : <FormControlLabel value="advance" sx={{ visibility: ((cashCount?.moduleType === "op" || cashCount?.moduleType === "self") && !props?.forReceivePayment && !fromRTmodule) ? "hidden" : "visible" }} control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>{fromRTmodule ? "RT Advance" : "Advance"}</Typography>} />}
                                {(props?.forReceivePayment || cashCount?.from_refund_request || (fromRTmodule && RtData?.rt_bill_type !== "Billed")) ? null : <FormControlLabel value="settle" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Settlement</Typography>} />}
                                {(cashCount?.moduleType === "self" || (!props?.fromFo && ((loggedInUserInfo?.module_name !== 'Pharmacy') || (loggedInUserInfo?.module_name === 'Pharmacy' && !showPharmacy)) && !cashCount?.from_refund_request) || fromRTmodule) ? null : <FormControlLabel value="refund" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Refund</Typography>} />}
                            </RadioGroup>
                        </Box>
                    </Box>
                    <Box component={'div'} sx={{ backgroundColor: STYLES.BOX_BACKGROUND_COLOR }}>
                        {props?.forReceivePayment ?
                            <Box component={'div'} height={'5dvh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} p={'0.5rem'} visibility={props?.forReceivePayment ? "visible" : 'hidden'}>
                                <Box component={'div'} display={'flex'}>
                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                        <Typography fontSize={'0.8rem'} >Available Advance Amount : </Typography>
                                        <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{showPharmacy && loginInfo?.module_name === "Pharmacy" ? `${AmountFormat(+PatientDetails?.pharmacy_advance_amount || 0)}` : fromRTmodule ? `${AmountFormat(+RtData?.advance_remaining || 0)}` : `${AmountFormat(+PatientDetails?.advance_amount || 0)}`}</Typography>
                                        {ipOrdertotalAmount ? <Typography sx={{ fontSize: "0.8vw", color: 'orangered', marginLeft: "1.5vw" }}>{`Note : An advance amount of ${AmountFormat(ipOrdertotalAmount)} will be adjusted against the orders you have selected.`}</Typography> : null}
                                    </Box>
                                </Box>
                            </Box> :
                            <Box component={'div'} height={'5dvh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} p={'0.5rem'} visibility={props?.forReceivePayment ? 'hidden' : "visible"}>
                                <Box component={'div'} display={'flex'}>
                                    {
                                        cashCount?.selectedRadio === "settle" ?
                                            <>
                                                <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                    <Typography fontSize={'0.8rem'} >Total Amount : </Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(totalBillingAmount)}`}</Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginX={"0.5vw"}>{`|`}</Typography>
                                                </Box>
                                                <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                    <Typography fontSize={'0.8rem'} >Paid Amount : </Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(totalpaidAmount)}`}</Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginX={"0.5vw"}>{`|`}</Typography>
                                                </Box>
                                                <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                    <Typography fontSize={'0.8rem'} >Outstanding Amount : </Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(maxOutstandingAmount)}`}</Typography>
                                                    <Typography fontSize={'0.8rem'} fontWeight={600} marginX={"0.5vw"}>{`|`}</Typography>
                                                </Box>
                                                {fromRTmodule ?
                                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                        <Typography fontSize={'0.8rem'} >Available Advance Amount : </Typography>
                                                        <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(+RtData?.advance_remaining || 0)}`}</Typography>
                                                    </Box> : null}
                                                {loginInfo?.module_name === "Pharmacy" && cashCount?.moduleType === "ip" && showPharmacy ?
                                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                        <Typography fontSize={'0.8rem'} >Pharmacy Advance Amount : </Typography>
                                                        <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(pharmacyAdv)}`}</Typography>
                                                    </Box> : null}
                                            </> :
                                            cashCount?.from_refund_request ?
                                                <>
                                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                        <Typography fontWeight={600} fontSize={'1rem'} >Refund Request </Typography>
                                                    </Box>
                                                </> :
                                                !props?.forReceivePayment ? <>
                                                    <>
                                                        <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                            <Typography fontSize={'0.8rem'} >Available Advance Amount : </Typography>
                                                            <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{showPharmacy && loginInfo?.module_name === "Pharmacy" ? `${AmountFormat(+PatientDetails?.pharmacy_advance_amount || 0)}` : fromRTmodule ? `${AmountFormat(+RtData?.advance_remaining || 0)}` : `${AmountFormat(+PatientDetails?.advance_amount || 0)}`}</Typography>
                                                            {ipOrdertotalAmount ? <Typography sx={{ fontSize: "0.8vw", color: 'orangered', marginLeft: "1.5vw" }}>{`Note : An advance amount of ${AmountFormat(ipOrdertotalAmount)} will be adjusted against the orders you have selected.`}</Typography> : null}
                                                        </Box>
                                                        {fromRTmodule ?
                                                            <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} mr={'0.8rem'}>
                                                                <Typography fontSize={'0.8rem'} >Total Bill Amount : </Typography>
                                                                <Typography fontSize={'0.8rem'} fontWeight={600} marginLeft={"0.5vw"}>{`${AmountFormat(+RtData?.bill_amount || 0)}`}</Typography>
                                                            </Box> : null}
                                                    </>
                                                </> : null
                                    }

                                </Box>
                            </Box>}
                        <Box component={'div'} height={'51dvh'}>
                            {(cashCount?.selectedRadio === 'advance' || cashCount?.selectedRadio === 'refund') ?
                                cashCount?.from_refund_request ?
                                    <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                                        <Paper elevation={3} sx={{ width: "30vw", margin: "1vw", padding: '0.5vw' }}>
                                            <Box>
                                                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: "space-between" }}>
                                                    <CommonPatientDetails data={location?.states?.refund_details} hideInsurance={true} />
                                                </Box>
                                            </Box>
                                            <Divider />
                                            <Box sx={{ margin: "1vw", }}>
                                                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", marginY: "1vw" }}>
                                                    <Typography>{location?.states?.fromRTRefund ? `WalkIn Number` : `OP/IP Number`}</Typography>
                                                    <Typography sx={{ fontWeight: 600 }}>{`${(location?.states?.refund_details?.op_number ? location?.states?.refund_details?.op_number : location?.states?.refund_details?.ip_numbers ? location?.states?.refund_details?.ip_numbers : location?.states?.refund_details?.self_patient ? location?.states?.refund_details?.self_patient : location?.states?.fromRTRefund ? location?.states?.refund_details?.walk_in_number : "-")}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", marginY: "1vw" }}>
                                                    <Typography>{"Bill Number"}</Typography>
                                                    <Typography sx={{ fontWeight: 600 }}>{`${(location?.states?.refund_details?.invoice_number ? location?.states?.refund_details?.invoice_number : "-")}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", marginY: "1vw" }}>
                                                    <Typography>{"Refundable Amount"}</Typography>
                                                    {/* <Typography sx={{ fontWeight: 600 }}>{`${AmountFormat(location?.states?.refund_details?.net_amount ? location?.states?.refund_details?.net_amount : 0)}`}</Typography> */}
                                                    <Typography sx={{ fontWeight: 600 }}>{`${AmountFormat(location?.states?.refund_details?.pharmacy_id ? location?.states?.refund_details?.return_amount : location?.states?.refund_details?.received_amount ? location?.states?.refund_details?.received_amount : 0)}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", marginY: "1vw" }}>
                                                    <Typography>{`Cancel Reason`}</Typography>
                                                    {location?.states?.refund_details?.cancel_reason ? location?.states?.refund_details?.cancel_reason.length > 40 ?
                                                        <Tooltip title={location?.states?.refund_details?.cancel_reason} placement="top" arrow>
                                                            <Typography fontSize={'0.9vw'}>{location?.states?.refund_details?.cancel_reason.slice(0, 38) + "..."}</Typography>
                                                        </Tooltip> : <Typography fontSize={'0.9vw'}>{location?.states?.refund_details?.cancel_reason}</Typography> : "-"}
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Box> :
                                    (cashCount?.selectedRadio === 'advance' && ipOrderList?.length) ?
                                        <Box>
                                            <TableContainer component={Paper} sx={{ height: '51dvh', overflow: 'auto' }}>
                                                <Table size='small'>
                                                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                        <TableRow>
                                                            <TableCell sx={{ padding: 0, paddingLeft: "1vw" }}>Module</TableCell>
                                                            <TableCell sx={{ padding: 0 }}>Number of Orders</TableCell>
                                                            <TableCell sx={{ padding: 0 }}>Total Amount</TableCell>
                                                            <TableCell sx={{ padding: 0 }}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {ipOrderList.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={4}>
                                                                    <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            ipOrderList.map((module, moduleIndex) => {
                                                                const allOrdersSelected = module.orders.every(order => order.selected);
                                                                const someOrdersSelected = module.orders.some(order => order.selected);
                                                                const moduleTotalAmount = module.orders.reduce((sum, order) => sum + order.total_amount, 0);

                                                                return (
                                                                    <React.Fragment key={moduleIndex}>
                                                                        {/* Module Row */}
                                                                        <TableRow>
                                                                            <TableCell sx={{ padding: 0, display: 'flex', alignItems: 'center' }}>
                                                                                <Checkbox
                                                                                    size="small"
                                                                                    checked={allOrdersSelected}
                                                                                    indeterminate={!allOrdersSelected && someOrdersSelected}
                                                                                    onChange={(e) => {
                                                                                        const checked = e.target.checked;
                                                                                        setIpOrdersList(prev => {
                                                                                            let updated = prev;

                                                                                            module.orders.forEach((order, oi) => {
                                                                                                updated = togglePackageSelection(
                                                                                                    updated,
                                                                                                    order,
                                                                                                    checked,
                                                                                                    moduleIndex,
                                                                                                    oi
                                                                                                );
                                                                                            });

                                                                                            return updated;
                                                                                        });
                                                                                    }}
                                                                                />
                                                                                <Typography sx={{ fontWeight: 600 }}>{module.module_type}</Typography>
                                                                            </TableCell>
                                                                            <TableCell sx={{ padding: 0 }}>{module.orders.length}</TableCell>
                                                                            <TableCell sx={{ padding: 0 }}>{AmountFormat(moduleTotalAmount)}</TableCell>
                                                                            <TableCell sx={{ padding: 0, paddingLeft: "1vw" }}>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => {
                                                                                        setIpOrdersList(prev =>
                                                                                            prev.map((m, i) =>
                                                                                                i === moduleIndex ? { ...m, open: !m.open } : m
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {module.open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>

                                                                        {/* Orders Subtable */}
                                                                        <TableRow>
                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                                                                                <Collapse in={module.open} timeout="auto" unmountOnExit>
                                                                                    <Table size="small" style={{ marginBottom: "10px" }}>
                                                                                        <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                                                            <TableRow>
                                                                                                <TableCell sx={{ padding: 0, paddingLeft: "1vw", width:"10%" }}>Select</TableCell>
                                                                                                <TableCell sx={{ padding: 0, width:"25%" }}>Order Number</TableCell>
                                                                                                <TableCell sx={{ padding: 0, width:"50%" }}>Service Name</TableCell>
                                                                                                <TableCell sx={{ padding: 0, width:"15%" }}>Total Amount</TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {module.orders.map((order, orderIndex) => (
                                                                                                <TableRow key={orderIndex}>
                                                                                                    <TableCell sx={{ padding: 0, paddingLeft: "1vw" }}>
                                                                                                        <Checkbox
                                                                                                            size="small"
                                                                                                            checked={order.selected || false}
                                                                                                            onChange={(e) => {
                                                                                                                const checked = e.target.checked;
                                                                                                                setIpOrdersList(prev =>
                                                                                                                    togglePackageSelection(prev, order, checked, moduleIndex, orderIndex)
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                    </TableCell>
                                                                                                    <TableCell sx={{ padding: 0 }}>{order.order_item_number}</TableCell>
                                                                                                    <TableCell sx={{ padding: 0 }}>{ContentInTooltip(order.service_name, 45, "0.875rem") }</TableCell>
                                                                                                    <TableCell sx={{ padding: 0 }}>{AmountFormat(order.total_amount)}</TableCell>
                                                                                                </TableRow>
                                                                                            ))}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </Collapse>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box> :
                                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                                            <img src={ImagePaths.NoDataImage.default} />
                                            <Typography sx={{ color: Colors?.grayShade }}>No Records to Show</Typography>
                                        </Box>
                                :
                                <TableContainer component={Paper} sx={{ height: '51dvh', overflow: 'auto' }}>
                                    <Table size='small'>
                                        <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: 0 }}>
                                                    <Checkbox
                                                        size='small'
                                                        checked={allBillsSelected}
                                                        indeterminate={!allBillsSelected && someBillsSelected}
                                                        onChange={handleSelectAllVisibleBills}
                                                    />
                                                </TableCell>
                                                <TableCell align='left' sx={{ padding: 0 }}>Bill Number</TableCell>
                                                <TableCell align='left' sx={{ padding: 0 }}>Credit Type</TableCell>
                                                <TableCell align='left' sx={{ padding: 0 }}>Bill Amount</TableCell>
                                                <TableCell align='left' sx={{ padding: 0 }}>Outstanding Amt</TableCell>
                                                <TableCell align='left' sx={{ padding: 0, width: '12dvw' }}>Receipt Amt</TableCell>
                                                {location?.states?.from_pharma_bills_list ? <TableCell sx={{ padding: 0 }} align="center">Action</TableCell> : null}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillDetails?.length === 0 ?
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell>
                                                        <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    {location?.states?.from_pharma_bills_list ? <TableCell></TableCell> : null}
                                                </TableRow>
                                                : BillDetails.map((row, Billindex) => (
                                                    <React.Fragment key={Billindex} sx={{ display: "flex", flexDirection: "column" }}>
                                                        <TableRow sx={{ display: (row?.services?.length > 0 || row?.bill_type === "pharmacy" || row?.bill_type === "ot" || row?.bill_type === "RT") ? "table-row" : "none" }}>
                                                            <TableCell align='left' sx={{ padding: 0 }}>
                                                                <Checkbox
                                                                    size='small'
                                                                    checked={row.bill_selected || false}
                                                                    onChange={() => handleCheckChange(row.index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ padding: 0 }}>
                                                                <Box sx={{ display: 'flex', alignItems: "center" }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
                                                                        <Typography fontSize={"0.8dvw"}>{row.invoice_number ? row.invoice_number : "-"}</Typography>
                                                                        <Typography fontSize={"0.7dvw"}>{row.invoice_date ? formatDateAndTimeMeth2(row.invoice_date) : "-"}</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell sx={{ padding: 0 }}>{row.credit_type ? row.credit_type : "-"}</TableCell>
                                                            <TableCell align='left' sx={{ padding: 0 }}>{AmountFormat(row.bill_amount)}</TableCell>
                                                            <TableCell align='left' sx={{ padding: 0 }}>{AmountFormat(row.outstanding_amount)}</TableCell>
                                                            <TableCell align='left' sx={{ padding: 0, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'space-between', flex: 0.2 }}>
                                                                {AmountFormat(row.receipt_amount)}
                                                                    <IconButton
                                                                        sx={{ marginLeft: "1vw", visibility: row?.services?.length > 0 ? "visible" : "hidden" }}
                                                                        onClick={() => {
                                                                            setBillDetails((prevRows) =>
                                                                                prevRows.map((row) =>
                                                                                    row.index === Billindex ? {
                                                                                        ...row,
                                                                                        open: !row?.open,
                                                                                    } : row
                                                                                )
                                                                            );
                                                                        }}>
                                                                        {row.open ? <ExpandLessIcon color='primary' /> : <ExpandMoreIcon color='primary' />}
                                                                    </IconButton>
                                                            </TableCell>
                                                            {location?.states?.from_pharma_bills_list ? (
                                                                <TableCell sx={{ padding: 0 }} align="center">
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25vw' }}>
                                                                        {(window.location.pathname === '/PharmacyBilling/CashCounter' && JSON.parse(localGetItem('enable_cash_counter_bill_modification') || 'false') && row?.bill_type === 'pharmacy') ? (
                                                                            <Tooltip title={row?.payment_status !== 'not paid' ? "Edit not allowed" : "Edit"}>
                                                                                <span>
                                                                                    <IconButton size="small" sx={{ marginLeft: '1.5vw' }} disabled={row?.payment_status !== 'not paid'} onClick={() => {
                                                                                        const patientDetails = {...(cashCount?.opNumber && { op_number: cashCount.opNumber }), ...cashCount.patient_details, ...PatientDetails, appointment_id: cashCount?.selectedAdmission?.appointment_id || PatientDetails?.appointment_id || cashCount.patient_details?.appointment_id };
                                                                                        const isSelf = location?.states?.patient_details?.is_self;
                                                                                        const patient_details = patientDetails ? { ...patientDetails, patient_account_number: patientDetails?.patient_account_number || patientDetails?.uhid, is_self: isSelf } : undefined;
                                                                                        localSetItem('from_cash_counter_edit', 'true');
                                                                                        history.push(history.location.pathname, {
                                                                                            from_cash_counter_edit: true,
                                                                                            Bill_ID: row?.bill_summary_id || row?.id,
                                                                                            billDetails: patientDetails,
                                                                                            from_pharmacy: true,
                                                                                            from_pharma_bills_list: true,
                                                                                            patient_details,
                                                                                            module: location?.states?.module,
                                                                                        });
                                                                                    }}>
                                                                                        <EditIcon fontSize="small" color={row?.payment_status !== 'not paid' ? "disabled" : "primary"} />
                                                                                    </IconButton>
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : null}
                                                                        <IconButton
                                                                            size="small"
                                                                            sx={{ visibility: row?.services?.length > 0 ? "visible" : "hidden" }}
                                                                            onClick={() => {
                                                                                setBillDetails((prevRows) =>
                                                                                    prevRows.map((r) =>
                                                                                        r.index === Billindex ? { ...r, open: !r?.open } : r
                                                                                    )
                                                                                );
                                                                            }}>
                                                                            {row.open ? <ExpandLessIcon color='primary' /> : <ExpandMoreIcon color='primary' />}
                                                                        </IconButton>
                                                                    </Box>
                                                                </TableCell>
                                                            ) : null}
                                                        </TableRow>
                                                        < TableRow >
                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                                                <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                                    <Table size="small" style={{ marginBottom: "10px" }}>
                                                                        <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                                            <TableRow>
                                                                                <TableCell sx={{ padding: 0, paddingLeft: "1vw" }}>Service Name</TableCell>
                                                                                <TableCell sx={{ padding: 0 }}>Module</TableCell>
                                                                                <TableCell align='left' sx={{ padding: 0 }}>Sub Amount</TableCell>
                                                                                <TableCell align='left' sx={{ padding: 0 }}>Outstanding Amt</TableCell>
                                                                                <TableCell align='left' sx={{ padding: 0 }}>Receipt Amt</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {row?.services?.length > 0 ? row?.services.map((item, i) => (
                                                                                <TableRow key={i} sx={{ height: "3.5dvh" }}>
                                                                                    <TableCell sx={{ padding: 0 }}>
                                                                                        {item.service_name ? item.service_name.length > 20 ?
                                                                                            <Tooltip title={item.service_name} placement="top" arrow>
                                                                                                <Typography fontSize={'0.9vw'}>{item.service_name.slice(0, 18) + "..."}</Typography>
                                                                                            </Tooltip> : <Typography fontSize={'0.9vw'}>{item.service_name}</Typography> : "-"}
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ padding: 0 }}>{item.module_type ? item.module_type : "-"}</TableCell>
                                                                                    <TableCell align='left' sx={{ padding: 0 }}>{AmountFormat(item.net_amount)}</TableCell>
                                                                                    <TableCell align='left' sx={{ padding: 0 }}>{AmountFormat(item.outstanding_amount)}</TableCell>
                                                                                    <TableCell align='left' sx={{ padding: 0 }}>{AmountFormat(item.receipt_amount)}</TableCell>
                                                                                </TableRow>
                                                                            )) : null}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer >}
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const showCashTextBox = () => {
        return (
            <Box component={'div'}>
                <Box component={'div'}>
                    <FormControlLabel control={<Checkbox disabled={!cashCount?.receivable_amt} size='small' checked={cashCount.isCash} onChange={(e) => handleCheckBox(e, 'isCash')} />} label="Cash" />
                    {cashCount?.selectedRadio === "refund" ? null : <FormControlLabel control={<Checkbox disabled={!cashCount?.receivable_amt} size='small' checked={cashCount.isCard} onChange={(e) => handleCheckBox(e, 'isCard')} />} label="Card" />}
                    <FormControlLabel control={<Checkbox disabled={!cashCount?.receivable_amt} size='small' checked={cashCount.isUPI} onChange={(e) => handleCheckBox(e, 'isUPI')} />} label="UPI" />
                    <FormControlLabel control={<Checkbox disabled={!cashCount?.receivable_amt} size='small' checked={cashCount.isBank} onChange={(e) => handleCheckBox(e, 'isBank')} />} label="Bank" />
                    {cashCount?.selectedRadio === "refund"  ? null : props?.noCheque ? null : (<FormControlLabel control={<Checkbox disabled={!cashCount?.receivable_amt} size='small' checked={cashCount.isCheque} onChange={(e) => handleCheckBox(e, 'isCheque')} />} label="Cheque" />)}
                </Box>
                <Box component={'div'}>
                    {cashCount.isCash ? cashTextBox('cash_amt', cashCount.cash_amt, 'Cash Amount', ImagePaths.CashIcon.default) : null}
                    {cashCount.isCard ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('card_amt', cashCount.card_amt, 'Card Amount', ImagePaths.CardIcon.default)}
                            {referenceTextBox('card_no', cashCount.card_no)}
                        </Box> : null}
                    {cashCount.isUPI ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('upi_amt', cashCount.upi_amt, 'UPI Amount', ImagePaths.UPIIcon.default)}
                            {referenceTextBox('upi_no', cashCount.upi_no)}
                        </Box> : null}
                    {cashCount.isBank ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('bank_amt', cashCount.bank_amt, 'Bank Amount', ImagePaths.BankTransferIcon.default)}
                            {referenceTextBox('bank_no', cashCount.bank_no)}
                        </Box> : null}
                    {cashCount.isCheque ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('cheque_amt', cashCount.cheque_amt, 'Cheque Amount', ImagePaths.ChequeIcon.default)}
                            {referenceTextBox('cheque_no', cashCount.cheque_no)}
                        </Box> : null}
                </Box>
                <Box component={'div'}><CashSplitter /></Box>
                <Box component={'div'} display={'flex'}>
                    {textBox('cash_collected', cashCount.cash_collected, 'Cash Collected', '10dvw', (+cashCount?.cash_amt ? false : true))}
                    {textBox('balance_amt', cashCount.balance_amt, 'Balance Amount', '10dvw', true)}
                </Box>
            </Box>
        )
    }

    const checkValidation = () => {
        try {
            let message = null
            if (checkTransationMandatory() &&
                ((cashCount.card_amt !== "" && cashCount.card_no === "") ||
                    (cashCount.upi_amt !== "" && cashCount.upi_no === "") ||
                    (cashCount.cheque_amt !== "" && cashCount.cheque_no === "") ||
                    (cashCount.bank_amt !== "" && cashCount.bank_no === ""))) {
                message = 'Please Enter Reference Number'
            } else if (
                (cashCount.card_no !== "" && cashCount.card_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.upi_no !== "" && cashCount.upi_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.cheque_no !== "" && cashCount.cheque_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.bank_no !== "" && cashCount.bank_no?.length < TXN_MSG_MAX_LEN)) {
                message = TXN_MSG_MAX
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postPharmacyCashCounter = () => {
        try {
            let payment = []; let billList = [];
            if (cashCount?.isCash) {
                payment.push(1)
            }
            if (cashCount?.isCard) {
                payment.push(2)
            }
            if (cashCount?.isUPI) {
                payment.push(3)
            }
            if (cashCount?.isCheque) {
                payment.push(4)
            }
            if (cashCount?.isBank) {
                payment.push(5)
            }
            let branch_id = localGetItem('BranchId')
            let ModuleId = ((cashCount?.selectedAdmission?.ip_admission_id ? (cashCount?.selectedAdmission?.ip_admission_id) : cashCount?.selectedAdmission?.appointment_id) || null)
            BillDetails?.filter((bill) => (bill?.bill_selected && bill?.bill_type === "pharmacy" && bill?.receipt_amount > 0))?.forEach(list => {
                billList?.push({
                    deduct_amount: +list?.receipt_amount || 0,
                    id: list?.id || null,
                    invoice_date: list?.invoice_date,
                    invoice_number: list?.invoice_number,
                    is_checked: list?.bill_selected,
                    module: 'Pharmacy',
                    net_amount: +list?.net_amount || 0,
                    patient_id: list?.patient_id || null,
                    pending_amount: +list?.net_amount || 0,
                    pharmacy_id: list?.pharmacy_id,
                    received_amount: +list?.receipt_amount || 0,
                    ...(showPharmacy && loginInfo?.module_name === "Pharmacy"
                        ? {
                            advance_deducted_amount: +list?.advance_deducted_amount || 0,
                            pharmacy_advance_only: +list?.advance_deducted_amount > 0 ? true : false
                        }
                        : {}),
                })
            })
            let data = {
                add_to_advance: false,
                amount_card: +cashCount.card_amt,
                amount_cash: +cashCount.cash_amt,
                bank_ref_no: cashCount.bank_no,
                bank_transfer_amount: +cashCount.bank_amt,
                branch_id: +branch_id,
                card_ref_no: cashCount.card_no,
                cheque_amount: +cashCount.cheque_amt,
                cheque_ref_no: cashCount.cheque_no,
                clinic_id: loginInfo?.clinic_id,
                collected_in: 'PHARMACY',
                ip_admission_id: cashCount?.moduleType === "ip" ? ModuleId : null,
                appointment_id: cashCount?.moduleType === "ip" ? null : ModuleId,
                module: ['pharmacy'],
                paid_amount: +cashCount?.receivable_amt || 0 || 0,
                patient_id: cashCount?.patient_details?.patient_id || null,
                payment_mode: payment,
                upi_amount: +cashCount.upi_amt,
                upi_ref_no: cashCount.upi_no,
                bill_list: billList,
                ...(showPharmacy && loginInfo?.module_name === "Pharmacy"
                    ? {
                        advance_adjusted: cashCount?.advance_deducted > 0,
                        advance_deducted_amount: cashCount?.advance_deducted || 0,
                    }
                    : {}),
            }

            RestAPIService.create(data, Serviceurls.NEW_FO_CREDIT_BILLS_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        LoaderFunction(false);
                        props.triggerNotifyCount(true);
                        if (!response.data?.data?.receipt_id && showPharmacy) {
                            successMessage(response.data.message);
                            ClosePopUp();
                        } else {
                            setSuccessPopup((prev) => ({
                                ...prev,
                                SuccessInvoice_ID: response.data.data?.bill_id,
                                bill_receipt_id: response.data?.data?.receipt_id,
                                isCredit: false,
                                patientId: null,
                                successText: response.data.message,
                                bill_module_type: response?.data?.data?.module_type
                            }))
                        }
                        getCollectionDetails()
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const createSequentialPaymentAllocator = (cashCount) => {
        let remainingCash = +cashCount?.cash_amt || 0;
        let remainingCard = +cashCount?.card_amt || 0;
        let remainingUpi = +cashCount?.upi_amt || 0;
        let remainingBank = +cashCount?.bank_amt || 0;
        let remainingCheque = +cashCount?.cheque_amt || 0;

        return (amount = 0) => {
            let billRemaining = +amount || 0;

            let payments = {
                cash_amount: 0,
                card_amount: 0,
                upi_amount: 0,
                bank_amount: 0,
                cheque_amount: 0,
            };

            if (billRemaining > 0 && remainingCash > 0) {
                const amt = Math.min(remainingCash, billRemaining);
                payments.cash_amount = +amt.toFixed(2);
                remainingCash -= amt;
                billRemaining -= amt;
            }

            if (billRemaining > 0 && remainingCard > 0) {
                const amt = Math.min(remainingCard, billRemaining);
                payments.card_amount = +amt.toFixed(2);
                remainingCard -= amt;
                billRemaining -= amt;
            }

            if (billRemaining > 0 && remainingUpi > 0) {
                const amt = Math.min(remainingUpi, billRemaining);
                payments.upi_amount = +amt.toFixed(2);
                remainingUpi -= amt;
                billRemaining -= amt;
            }

            if (billRemaining > 0 && remainingBank > 0) {
                const amt = Math.min(remainingBank, billRemaining);
                payments.bank_amount = +amt.toFixed(2);
                remainingBank -= amt;
                billRemaining -= amt;
            }

            if (billRemaining > 0 && remainingCheque > 0) {
                const amt = Math.min(remainingCheque, billRemaining);
                payments.cheque_amount = +amt.toFixed(2);
                remainingCheque -= amt;
                billRemaining -= amt;
            }

            return payments;
        };
    };

    const postCashCounter = () => {
        try {
            let check = checkValidation()
            if (check === null) {
                LoaderFunction(true);
                let payment = []
                if (cashCount?.isCash) {
                    payment.push(1)
                }
                if (cashCount?.isCard) {
                    payment.push(2)
                }
                if (cashCount?.isUPI) {
                    payment.push(3)
                }
                if (cashCount?.isCheque) {
                    payment.push(4)
                }
                if (cashCount?.isBank) {
                    payment.push(5)
                }
                const selectedBills = (BillDetails ?? []).filter(b => b.bill_selected);
                const allocatePayment = createSequentialPaymentAllocator(cashCount);
                const allItems = selectedBills.flatMap(bill => {
                    const isSingleLineBill =
                        bill.bill_type === 'pharmacy' ||
                        bill.bill_type === 'ot';

                    // PHARMACY / OT → single line item
                    if (isSingleLineBill) {
                        return bill.receipt_amount > 0
                            ? [{
                                bill,
                                service: null,
                                amount: bill.receipt_amount
                            }]
                            : [];
                    }

                    // IP / OP / LAB → service based
                    return (bill.services ?? [])
                        .filter(s => s.receipt_amount > 0)
                        .map(service => ({
                            bill,
                            service,
                            amount: service.receipt_amount
                        }));
                });

                const allocatedItems = allItems.map(({ bill, service }) => {
                    const isSingleLineBill =
                        bill.bill_type === 'pharmacy' ||
                        bill.bill_type === 'ot';

                    const amountToAllocate = isSingleLineBill
                        ? bill.receipt_amount
                        : service.receipt_amount || 0;

                    const payments = allocatePayment(amountToAllocate);

                    return {
                        bill_id: bill.id,

                        // For pharmacy & OT, item id = bill id
                        id: isSingleLineBill ? bill.id : service.id,

                        // Net amount source differs
                        net_amount: isSingleLineBill
                            ? +bill.bill_amount || 0
                            : +service.net_amount || 0,

                        received_amount:
                            payments.cash_amount +
                            payments.card_amount +
                            payments.upi_amount +
                            payments.bank_amount +
                            payments.cheque_amount,

                        bill_type: bill.bill_type,

                        ...payments
                    };
                });
                let OtherBills = BillDetails?.filter((bill) => (bill.bill_selected && bill?.bill_type !== "pharmacy" && bill.bill_type !== "ot"))?.map((bill) => {
                    const items = allocatedItems.filter(i => i.bill_id === bill.id);
                    const sum = (key) => items.reduce((t, i) => t + i[key], 0);
                    return {
                        "id": bill?.id || null,
                        "net_amount": +bill?.bill_amount || +bill?.net_amount || 0,
                        "payment_status": +bill?.receipt_amount === 0 ? 'not paid' : +bill?.outstanding_amount === +bill?.receipt_amount ? 'paid' : "partial",
                        "received_amount": sum('received_amount'),
                        "credit_type": bill?.credit_type || "",
                        "cash_amount": sum('cash_amount'),
                        "card_amount": sum('card_amount'),
                        "upi_amount": sum('upi_amount'),
                        "bank_amount": sum('bank_amount'),
                        "cheque_amount": sum('cheque_amount'),
                        "bill_items": items?.map((list) => {
                            return {
                                "id": list?.id || null,
                                "net_amount": +list?.net_amount || 0,
                                "payment_status": +list?.received_amount === 0 ? 'not paid' : +list?.received_amount === +list?.net_amount ? 'paid' : "partial",
                                "received_amount": list.received_amount,
                                cash_amount: list.cash_amount,
                                card_amount: list.card_amount,
                                upi_amount: list.upi_amount,
                                bank_amount: list.bank_amount,
                                cheque_amount: list.cheque_amount
                            }
                        }),
                    }
                })?.filter((bill) => bill.bill_items?.length > 0)
                let ModuleId = ((cashCount?.selectedAdmission?.ip_admission_id ? (cashCount?.selectedAdmission?.ip_admission_id) : cashCount?.selectedAdmission?.appointment_id) || null)
                let data = {
                    "bills": OtherBills?.length ? OtherBills : [],
                    "ph_bills": BillDetails?.filter((bill) => (bill?.bill_selected && bill?.bill_type === "pharmacy" && bill?.receipt_amount > 0))?.map((list) => {
                        const items = allocatedItems.filter(i => i.bill_id === list.id);
                        const sum = (key) => items.reduce((t, i) => t + i[key], 0);
                        return {
                        "id": list?.id || null,
                        "net_amount": +list?.bill_amount || +list?.net_amount || 0,
                        "invoice_number": list?.invoice_number,
                        "invoice_date": list?.invoice_date,
                        "credit_type": list?.credit_type,
                        "payment_status": +list?.receipt_amount === 0 ? 'not paid' : +list?.outstanding_amount === +list?.receipt_amount ? 'paid' : "partial",
                        "received_amount": sum('received_amount'),
                        "cash_amount": sum('cash_amount'),
                        "card_amount": sum('card_amount'),
                        "upi_amount": sum('upi_amount'),
                        "bank_amount": sum('bank_amount'),
                        "cheque_amount": sum('cheque_amount'),
                        }
                    }),
                    "ot_bills": BillDetails?.filter((bill) => (bill?.bill_selected && bill?.bill_type === "ot" && bill?.receipt_amount > 0))?.map((list) => {
                        const items = allocatedItems.filter(i => i.bill_id === list.id);
                        const sum = (key) => items.reduce((t, i) => t + i[key], 0);
                        return {
                        "id": list?.id || null,
                        "net_amount": +list?.bill_amount || +list?.net_amount || 0,
                        "invoice_number": list?.invoice_number,
                        "invoice_date": list?.invoice_date,
                        "credit_type": list?.credit_type,
                        "payment_status": +list?.receipt_amount === 0 ? 'not paid' : +list?.outstanding_amount === +list?.receipt_amount ? 'paid' : "partial",
                        "received_amount": sum('received_amount'),
                        "cash_amount": sum('cash_amount'),
                        "card_amount": sum('card_amount'),
                        "upi_amount": sum('upi_amount'),
                        "bank_amount": sum('bank_amount'),
                        "cheque_amount": sum('cheque_amount'),
                        }
                    }),
                    "receipt": {
                        "payment_mode": payment,
                        "received_amount": +cashCount?.receivable_amt || 0,
                        "cash_amount": +cashCount?.cash_amt || 0,
                        "card_amount": +cashCount?.card_amt || 0,
                        "upi_amount": +cashCount?.upi_amt || 0,
                        "bank_amount": +cashCount?.bank_amt || 0,
                        "cheque_amount": +cashCount?.cheque_amt || 0,
                        "card_ref_no": cashCount?.card_no || "",
                        "upi_ref_no": cashCount?.upi_no || "",
                        "bank_ref_no": cashCount?.bank_no || "",
                        "cheque_ref_no": cashCount?.cheque_no || "",
                    },
                    "patient_id": cashCount?.patient_details?.patient_id || null,
                    "appointment_id": cashCount?.moduleType === "ip" ? null : ModuleId,
                    "ip_admission_id": cashCount?.moduleType === "ip" ? ModuleId : null
                }
                RestAPIService.create(data, (cashCount?.moduleType === "ip" ? Serviceurls.CASH_COUNTER_POST_IP : Serviceurls.CASH_COUNTER_POST))
                    .then((response) => {
                        if (response.data.status === 'success') {
                            LoaderFunction(false);
                            // successMessage(response.data.message);
                            props.triggerNotifyCount(true);
                            setSuccessPopup((prev) => ({
                                ...prev,
                                SuccessInvoice_ID: response.data.data?.bill_id,
                                bill_receipt_id: response.data?.data?.receipt_id,
                                isCredit: true,
                                patientId: null,
                                successText: response.data.message,
                                bill_module_type: response?.data?.data?.module_type
                            }))
                            // if(maxOutstandingAmount === +cashCount?.receivable_amt ){
                            // clearFunction(true)
                            // }else{
                            //     clearFunction()
                            // }
                            getCollectionDetails()
                            // getBillsData()
                        }
                    }).catch((error) => {
                        LoaderFunction(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error.response.data.message);
                        } else {
                            errorMessage(error.message);
                        }
                    });
            } else {
                errorMessage(check)
            }
        }
        catch (error) {
            LoaderFunction(false);
            errorMessage(error.message)
        }
    }

    const postRTAdvanceAmount = (forSettle = false, forReturn = false) => {
        try {
            let check = checkValidation()
            LoaderFunction(true);
            let payment = []
            if (cashCount?.isCash) {
                payment.push(1)
            }
            if (cashCount?.isCard) {
                payment.push(2)
            }
            if (cashCount?.isUPI) {
                payment.push(3)
            }
            if (cashCount?.isCheque) {
                payment.push(4)
            }
            if (cashCount?.isBank) {
                payment.push(5)
            }
            let FullAdvPayment = forSettle && (+(cashCount?.receivable_amt - RtAdvanceAdjected) === 0)
            let startDate = new Date()
            let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
            const invoice_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""

            var Smsdate = new Date(RtsmsRemainderDate);
            let remainderDate = DateTime.fromJSDate(Smsdate).toFormat('yyyy-MM-dd');
            let data = {
                'patient_id': forReturn ? location?.states?.refund_details?.patient_id : (RtData?.patient_id || null),
                'radiotherapy_id': RtData?.radiotherapy_id || null,
                'walk_in_id': location?.states?.refund_details?.walk_in_id || RtData?.id || null,
                'receipt_type': (forSettle || forReturn) ? "Receipt" : 'Advance',
                'receipt_for': forReturn ? "Refund" : forSettle ? "Bill" : 'Advance',
                'invoice_date': invoice_date,
                'received_amount': forReturn ? location?.states?.refund_details?.received_amount : forSettle ? (+(cashCount?.receivable_amt - RtAdvanceAdjected) || 0) : +(cashCount?.receivable_amt),
                "cash_amount": FullAdvPayment ? 0 : (+cashCount?.cash_amt || 0),
                "card_amount": FullAdvPayment ? 0 : (+cashCount?.card_amt || 0),
                "upi_amount": FullAdvPayment ? 0 : (+cashCount?.upi_amt || 0),
                "bank_amount": FullAdvPayment ? 0 : (+cashCount?.bank_amt || 0),
                "cheque_amount": FullAdvPayment ? 0 : (+cashCount?.cheque_amt || 0),
                "payment_mode": payment,
                "card_ref_no": FullAdvPayment ? "" : (cashCount?.card_no || ""),
                "upi_ref_no": FullAdvPayment ? "" : (cashCount?.upi_no || ""),
                "bank_ref_no": FullAdvPayment ? "" : (cashCount?.bank_no || ""),
                "cheque_ref_no": FullAdvPayment ? "" : (cashCount?.cheque_no || ""),
                'collected_in': 'FO',
                'advance_adjusted_amount': RtAdvanceAdjected || 0,
                'overall_received_amount': forReturn ? location?.states?.refund_details?.received_amount : +cashCount?.receivable_amt || 0,
                'sms_reminder_date': RtsmsRemainderDate ? remainderDate : null,
            }
            if (check !== null) {
                LoaderFunction(false);
                errorMessage(check)
            } else {
                RestAPIService.create(data, Serviceurls.RT_RECEIVE_PAYMENTS)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            LoaderFunction(false);
                            successMessage(response.data.message);
                            if (location?.states?.return_path) {
                                history.push({ pathname: location?.states?.return_path })
                            } else {
                                if (forReturn) {
                                    props?.getRefundRefundCOunt()
                                }
                                clearFunction(true)
                            }
                        }
                    }).catch((error) => {
                        LoaderFunction(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error.response.data.message);
                        } else {
                            errorMessage(error.message);
                        }
                    });
            }
        }
        catch (error) {
            errorMessage(error.message)
        }
    }
    const postAdvanceAmount = () => {
        try {
            let check = checkValidation()
            LoaderFunction(true);
            let payment = []
            if (cashCount?.isCash) {
                payment.push(1)
            }
            if (cashCount?.isCard) {
                payment.push(2)
            }
            if (cashCount?.isUPI) {
                payment.push(3)
            }
            if (cashCount?.isCheque) {
                payment.push(4)
            }
            if (cashCount?.isBank) {
                payment.push(5)
            }
            let data = {
                "patient_id": cashCount?.patient_details?.patient_id || JSON.parse(getCachevalue("IppatientData"))?.patient_id || null,
                "ip_admission_id": (cashCount?.selectedAdmission?.ip_admission_id ? (cashCount?.selectedAdmission?.ip_admission_id) : cashCount?.selectedAdmission?.appointment_id) || JSON.parse(getCachevalue("IppatientData"))?.id || null,
                "advance_amount": cashCount?.selectedRadio === 'advance' ? (+cashCount?.receivable_amt || 0) : 0,
                "is_refund": cashCount?.selectedRadio === 'advance' ? false : true,
                "refund_amount": cashCount?.selectedRadio === 'advance' ? 0 : (+cashCount?.receivable_amt || 0),
                "cash_amount": +cashCount?.cash_amt || 0,
                "card_amount": +cashCount?.card_amt || 0,
                "upi_amount": +cashCount?.upi_amt || 0,
                "bank_amount": +cashCount?.bank_amt || 0,
                "cheque_amount": +cashCount?.cheque_amt || 0,
                "payment_mode": payment,
                "card_ref_no": cashCount?.card_no || "",
                "upi_ref_no": cashCount?.upi_no || "",
                "bank_ref_no": cashCount?.bank_no || "",
                "cheque_ref_no": cashCount?.cheque_no || "",
                "order_list": [],
            }
            if (ipOrderList?.length) {
                const selectedOrders = ipOrderList.flatMap(module =>
                    module.orders
                        .filter(order => order.selected)
                        .map(order => ({
                            order_id: order.id,
                            advance_amount: +order.total_amount || 0
                        }))
                );
                data["order_list"] = selectedOrders
            }
            if (check !== null) {
                LoaderFunction(false);
                errorMessage(check)
            } else {
                let URL = loginInfo?.module_name === "Pharmacy" ? Serviceurls.CASH_COUNTER_ADVANCE_POST_PHAR : Serviceurls.CASH_COUNTER_ADVANCE_POST
                RestAPIService.create(data, URL)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            LoaderFunction(false);
                            // successMessage(response.data.message);
                            setSuccessPopup((prev) => ({
                                ...prev,
                                SuccessInvoice_ID: response.data.data?.bill_id,
                                bill_receipt_id: response.data?.data?.receipt_id,
                                isCredit: false,
                                patientId: null,
                                successText: response.data.message,
                                bill_module_type: response?.data?.data?.module_type
                            }))
                             if (ipOrderList?.length) {
                                setIpOrdersList([])
                                getipOrdersList()
                             }
                            // if (props?.forReceivePayment) {
                            //     getPatientDetails(PatientDetails?.ip_admission_id)
                            //     clearFunction()
                            // } else {
                            //     clearFunction(true)
                            // }
                        }
                    }).catch((error) => {
                        LoaderFunction(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error.response.data.message);
                        } else {
                            errorMessage(error.message);
                        }
                    });
            }
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const postRefundAccept = () => {
        try {
            LoaderFunction(true);
            let payment = []
            if (cashCount?.isCash) {
                payment.push(1)
            }
            if (cashCount?.isCard) {
                payment.push(2)
            }
            if (cashCount?.isUPI) {
                payment.push(3)
            }
            if (cashCount?.isCheque) {
                payment.push(4)
            }
            if (cashCount?.isBank) {
                payment.push(5)
            }
            let data = {
                "bill_id": location?.states?.refund_details?.id || null,
                "receipt_type": location?.states?.refund_details?.request_type || "",
                // "received_amount": location?.states?.refund_details?.net_amount || 0,
                "received_amount": location?.states?.refund_details?.pharmacy_id ? (location?.states?.refund_details?.return_amount || 0) : (location?.states?.refund_details?.received_amount || 0),
                "cash_amount": +cashCount?.cash_amt || 0,
                "upi_amount": +cashCount?.upi_amt || 0,
                "bank_amount": +cashCount?.bank_amt || 0,
                "payment_mode": payment,
                "upi_ref": cashCount?.upi_no || "",
                "bank_ref": cashCount?.bank_no || "",
                "pharmacy_id": cashCount?.pharmaReturnData?.pharmacy_id || null,
                "line_item": [],
            }
            if (
                (cashCount.card_no !== '' && cashCount.card_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.bank_no !== '' && cashCount.bank_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.upi_no !== '' && cashCount.upi_no?.length < TXN_MSG_MAX_LEN) ||
                (cashCount.cheque_no !== '' && cashCount.cheque_no?.length < TXN_MSG_MAX_LEN)
            ) {
                errorMessage(TXN_MSG_MAX)
                LoaderFunction(false);
            } else {
                RestAPIService.create(data, Serviceurls.NEW_BILING_CANCEL_REQUEST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            LoaderFunction(false);
                            // successMessage(response.data.message);
                            setSuccessPopup((prev) => ({
                                ...prev,
                                SuccessInvoice_ID: response.data.data?.bill_id,
                                bill_receipt_id: response.data?.data?.receipt_id,
                                bill_module_type: response.data?.data?.module_type,
                                isCredit: false,
                                patientId: null,
                                successText: response.data.message
                            }))
                            props?.getRefundRefundCOunt()
                            clearFunction(true)
                        }
                    }).catch((error) => {
                        LoaderFunction(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error.response.data.message);
                        } else {
                            errorMessage(error.message);
                        }
                    });
            }
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const postSafetyDepositAmount = () => {
        try {
            LoaderFunction(true);
            let payment = []
            if (cashCount?.isCash) {
                payment.push(1)
            }
            if (cashCount?.isCard) {
                payment.push(2)
            }
            if (cashCount?.isUPI) {
                payment.push(3)
            }
            if (cashCount?.isCheque) {
                payment.push(4)
            }
            if (cashCount?.isBank) {
                payment.push(5)
            }
            let data = {
                "patient_id": cashCount?.patient_details?.patient_id || null,
                "ip_admission_id": cashCount?.patient_details?.id || JSON.parse(getCachevalue("IppatientData"))?.id || null,
                "receipt_type": cashCount?.selectedRadio === 'advance' ? "Advance" : "Refund",
                "received_amount": (+cashCount?.receivable_amt || 0),
                "cash_amount": +cashCount?.cash_amt || 0,
                "card_amount": +cashCount?.card_amt || 0,
                "upi_amount": +cashCount?.upi_amt || 0,
                "bank_amount": +cashCount?.bank_amt || 0,
                "cheque_amount": +cashCount?.cheque_amt || 0,
                "payment_mode": payment,
                "card_ref_no": cashCount?.card_no || "",
                "upi_ref_no": cashCount?.upi_no || "",
                "bank_ref_no": cashCount?.bank_no || "",
                "cheque_ref_no": cashCount?.cheque_no || "",
                "payment_date": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "receipt_for": cashCount?.selectedRadio === 'advance' ? "Safety Deposit" : "Refund",
            }
            let check = checkValidation()
            if (check !== null) {
                LoaderFunction(false);
                errorMessage(check)
            } else {
                RestAPIService.create(data, Serviceurls.IP_SAFETY_DEPOSIT_RECEIVE_PAYMENT)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            LoaderFunction(false);
                            // successMessage(response.data.message);
                            // getPatientDetails(JSON.parse(getCachevalue("IppatientData"))?.id)
                            setSuccessPopup((prev) => ({
                                ...prev,
                                SuccessInvoice_ID: response.data.data?.bill_id,
                                bill_receipt_id: response.data?.data?.receipt_id,
                                bill_module_type: response.data?.data?.module_type,
                                isCredit: false,
                                patientId: null,
                                successText: response.data.message
                            }))
                            setPharmaBillDetails([])
                            setOtBillDetails([])
                            setDuplicatetBillDetails([])
                            // clearFunction(true)
                            getCollectionDetails()
                        }
                    }).catch((error) => {
                        LoaderFunction(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error.response.data.message);
                        } else {
                            errorMessage(error.message);
                        }
                    });
            }
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const clearFunction = (ForceReload = false) => {
        if (ForceReload) {
            setBillDetails([])
            setPharmaBillDetails([])
            setOtBillDetails([])
            setDuplicatetBillDetails([])
            setPatientDetails({})
            setAdvAutoApplied(false)
            setPharmacyAdv(0)
            if(props.VisitDateBalAmount && loggedInUserInfo?.module_name === 'front_office'){
                props.VisitDateBalAmount({})
            }
            if (fromRTmodule) {
                setFromRTmodule(false)
                setRtData(null)
                history.push({ pathname: "/HospitalBilling/CashCounter", states: {} })
            }
            setCashCount((prev) => ({
                ...prev,
                searchPhoneUhid: '', searchIPOPNo: '', searchBillNo: '',
                patientSuggData: [], patient_details: {},
                receivable_amt: null, selectedRadio: 'settle',
                isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                upi_no: '', cheque_amt: '', cheque_no: '', page: 0, pageSize: 10,
                openReceipt: false, cash_collected: '', balance_amt: '', open: false, services: [], moduleType: "op",
                pharamacyList: [], AdmissionLists: [], selectedAdmission: null, getBillsFlag: false,
                advance_type: "advance", refund_type: "advance", include_pharmacy: false, from_refund_request: false,
                advCheck: false, advance_deducted: ''
            }))
            setMaxOutshandingAmount(0)
            setTotalPaidAmount(0)
            setTotalBillingAmount(0)
            setPostBtnDisble(false)
            if (cashCount?.from_refund_request) {
                props.getRefundRefundCOunt(true)
            }
        } else {
            setBillDetails([])
            setPharmaBillDetails([])
            setOtBillDetails([])
            setDuplicatetBillDetails([])
            setAdvAutoApplied(false)
            setCashCount((prev) => ({
                ...prev,
                receivable_amt: null,
                isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                upi_no: '', cheque_amt: '', cheque_no: '', page: 0, pageSize: 10,
                openReceipt: false, from_refund_request: false,
                advCheck: false, advance_deducted: ''
            }))
            setMaxOutshandingAmount(0)
            setTotalPaidAmount(0)
            setTotalBillingAmount(0)
            setPostBtnDisble(false)
            if (cashCount?.from_refund_request) {
                props.getRefundRefundCOunt(true)
            }
        }
    }

    const renderPatientDetails = () => {
        return (
            <Box component={'div'} height={'10dvh'} p={'0.5rem'} display={'flex'}>
                {newAmountCard('Available Advance', PatientDetails?.advance_amount, false, 'white', false, 'white', 'tlt_pat', '8dvw', '', '8dvh')}
                {loginInfo?.show_pharmacy_advance ? newAmountCard('Pharmacy Advance', pharmacyAdv, false, 'white', false, 'white', 'tlt_phar', '8dvw', '0.5rem', '8dvh') : null}
                {newAmountCard(`Bill Amount ${loginInfo?.show_pharmacy_advance ? 'Include Pharmacy' : ""}`, PatientDetails?.service_amount, false, 'white', false, 'white', 'tlt_bill_amt', '8dvw', '0.5rem', '8dvh')}
                {newAmountCard('Received Amount', PatientDetails?.paid_amount, false, 'white', false, 'white', 'tlt_crdt', '8dvw', '0.5rem', '8dvh')}
                {newAmountCard('Balance Amount', PatientDetails?.balance_amount, false, 'white', false, 'white', 'tlt_rfd', '8dvw', '0.5rem', '8dvh')}
                {newAmountCard('Approx Amount', ApproxCharges, false, 'white', false, 'white', 'tlt_cal', '8dvw', '0.5rem', '8dvh')}
                {newAmountCard('Claimed Amount', PatientDetails?.claimed_amount, false, 'white', false, 'white', 'tlt_cal', '8dvw', '0.5rem', '8dvh')}
            </Box>
        )
    }

    const renderGridThree = () => {
        const userAccess = (props?.forReceivePayment && props?.fromFo && LoggedUserData?.is_user) ? CheckAccessFunc("front_office", "In Patients", "Receive Payment", null, "Tab")?.editAccess : true;
        try {
            const allowPayment = (+cashCount?.receivable_amt && (+cashCount?.receivable_amt === ((+cashCount?.cash_amt || 0) + (+cashCount?.card_amt || 0) + (+cashCount?.upi_amt || 0) + (+cashCount?.bank_amt || 0) + (+cashCount?.cheque_amt || 0))) || (+cashCount?.receivable_amt === 0 && cashCount?.advance_deducted > 0 && showPharmacy));
            const allowRTPayment = (cashCount?.selectedRadio === 'settle' && (+cashCount.receivable_amt - RtAdvanceAdjected) === 0) ? true : (+(+cashCount.receivable_amt - RtAdvanceAdjected) && (+(+cashCount.receivable_amt - RtAdvanceAdjected) === ((+cashCount?.cash_amt || 0) + (+cashCount?.card_amt || 0) + (+cashCount?.upi_amt || 0) + (+cashCount?.bank_amt || 0) + (+cashCount?.cheque_amt || 0))))
            const isFullyCoveredByAdvance = Number(maxOutstandingAmount) > 0 && Number(maxOutstandingAmount) === Number(cashCount?.advance_deducted);
            return (
                <Box component={'div'} border={'1px solid lightgray'} borderRadius={"4px"}>
                    <Box component={'div'} p={'0.5rem'}>
                        <Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Receipt Details</Typography>
                    </Box>
                    <Box component={'div'} sx={{ backgroundColor: STYLES.BOX_BACKGROUND_COLOR }}>
                        <Box component={'div'} height={'50dvh'} overflow={'auto'} p={'0.5rem'}>
                            {(props?.forReceivePayment && (localGetItem("enable_safety_deposit") === "true" && localGetItem("safety_deposit_permission") === "true")) ? <Box component={'div'}>
                                {
                                    (cashCount?.selectedRadio === 'advance') ?
                                        <RadioGroup
                                            row
                                            value={cashCount.advance_type}
                                            onChange={(e) => { setCashCount((prev) => ({ ...prev, advance_type: e.target.value })) }}
                                        >
                                            <FormControlLabel value="advance" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Advance</Typography>} />
                                            <FormControlLabel value="safety_deposit" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Safety Deposit</Typography>} />
                                        </RadioGroup> :
                                        (cashCount?.selectedRadio === 'refund' && +PatientDetails?.safety_deposit_amount) ?
                                            <RadioGroup
                                                row
                                                value={cashCount.refund_type}
                                                onChange={(e) => { setCashCount((prev) => ({ ...prev, refund_type: e.target.value })) }}
                                            >
                                                <FormControlLabel value="advance" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Advance Refund</Typography>} />
                                                <FormControlLabel value="safety_deposit" control={<Radio size='small' />} label={<Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Safety Deposit Refund</Typography>} />
                                            </RadioGroup> : null
                                }

                            </Box> : null}
                            {loginInfo?.module_name === "Pharmacy" && cashCount?.moduleType === "ip" && cashCount?.selectedRadio === 'settle' && pharmacyAdv > 0 && showPharmacy ?
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <FormControlLabel control={<Checkbox size='small' checked={cashCount?.advCheck} onChange={(e) => {
                                        const checked = e.target.checked;
                                        setAdvAutoApplied(true);
                                        setIsAdvAmountManual(false);
                                        setCashCount(prev => {
                                            if (!checked) {
                                                return {
                                                    ...prev,
                                                    advCheck: false,
                                                    advance_deducted: ""
                                                };
                                            }
                                            const adv = Number(pharmacyAdv) || 0;
                                            const outstanding = Number(maxOutstandingAmount) || 0;
                                            if (AutoAdvFetch) {
                                                return {
                                                    ...prev,
                                                    advCheck: true,
                                                    advance_deducted: Math.min(adv, outstanding)
                                                };
                                            } else {
                                                return {
                                                    ...prev,
                                                    advCheck: true
                                                };
                                            }
                                        });
                                    }} />} label={<Typography fontSize={'0.9rem'}>Deduct from advance</Typography>} />
                                    <TextField
                                        autoComplete='off'
                                        size='small'
                                        InputProps={{ emed_tid: 'con_amt', style: { height: '4dvh' } }}
                                        sx={{ width: '8dvw' }}
                                        disabled={!cashCount?.advCheck}
                                        placeholder={CurrencySymbol}
                                        value={cashCount?.advance_deducted || ""}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            setIsAdvAmountManual(true);
                                            if ((CommonValidation.numberOnly(value) && ((+value >= 1 && +value + (+cashCount?.receivable_amt)) <= maxOutstandingAmount) && +value <= pharmacyAdv) || value === '') {
                                                setCashCount((prev) => ({ ...prev, advance_deducted: +value }))
                                            }
                                        }}
                                    />
                                </Box>
                                : null}
                            <Box component={'div'}>
                                {textBox('receivable_amt', cashCount.receivable_amt, (cashCount?.selectedRadio === "settle" ? 'Receivable Amount' : cashCount?.selectedRadio === "advance" ? 'Advance Amount' : "Refund Amount"), '15dvw', (cashCount?.from_refund_request || ipOrdertotalAmount || isFullyCoveredByAdvance))}
                                {(fromRTmodule && cashCount?.selectedRadio === 'settle' && cashCount.receivable_amt) ? <Typography sx={{ marginTop: "0.3vw" }}>{`Adjusted RT Advance : ${RtAdvanceAdjected}`}</Typography> : null}
                                {(fromRTmodule && cashCount?.selectedRadio === 'settle' && cashCount.receivable_amt) ? <Typography sx={{ marginTop: "0.3vw" }}>{`Payable Amount : ${+cashCount.receivable_amt - RtAdvanceAdjected}`}</Typography> : null}
                            </Box>
                            <Box component={'div'} mt={'0.5rem'} sx={{ display: (cashCount?.receivable_amt && fromRTmodule && (+cashCount?.receivable_amt - RtAdvanceAdjected) === 0) ? "none" : 'block' }}>
                                <Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Payment Mode</Typography>
                                <Box component={'div'} mb={'0.5rem'}>{showCashTextBox()}</Box>
                            </Box>
                            <Box component={'div'} mt={'0.5rem'} sx={{ display: (fromRTmodule && LoggedUserData?.sms_config?.sms_remainder_for_radiotherapy_bills && cashCount?.receivable_amt && +RtData?.bill_amount > (+RtData?.advance_remaining + +cashCount?.receivable_amt)) ? "block" : "none" }}>
                                <Typography fontSize={STYLES.FONT_SIZE_MED} fontWeight={STYLES.FONT_WEIGHT}>Outstanding Remainder SMS Date</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={RtsmsRemainderDate ? RtsmsRemainderDate : null}
                                        name={"datePicker"}
                                        inputFormat={'DD-MM-YYYY'}
                                        views={["year", "month", "day"]}
                                        onChange={(newDate) => {
                                            setRTSmsRemainderDate(newDate)
                                        }}
                                        minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            label={" SMS Date"}
                                            variant="outlined"
                                            onKeyDown={(e) => e.preventDefault()}
                                            sx={{ width: '14dvw', marginRight: '0.3vw', marginTop: "0.5vw" }}
                                            size='small'
                                        />}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0.5rem'}>
                            {location?.states?.return_path ? <Button variant='outlined' sx={{ height: '4dvh', textTransform: 'capitalize', mr: '1rem' }} onClick={() => { history.push({ pathname: location?.states?.return_path }) }}>{`${location?.states?.back_button_lable || "Back"}`}</Button> : null}
                            <Button variant='outlined' sx={{ height: '4dvh', textTransform: 'capitalize', mr: '1rem' }} onClick={() => clearFunction(true)}>Clear</Button>
                            <Button
                                disabled={(fromRTmodule ? !allowRTPayment : !allowPayment) || postBtnDisble || !userAccess}
                                variant='contained'
                                sx={{ height: '4dvh', textTransform: 'capitalize', mr: '1rem' }}
                                onClick={() => {
                                    setPostBtnDisble(true)
                                }}>{cashCount?.selectedRadio === "settle" ? (fromRTmodule && cashCount.receivable_amt && (+cashCount.receivable_amt - RtAdvanceAdjected) === 0) ? "Adject from Advance" : "Receive Payment" : cashCount?.selectedRadio === "advance" ? "Receive Advance" : "Refund"}</Button>
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const ClosePopUp = () => {
        setSuccessPopup((prev) => ({
            ...prev,
            SuccessInvoice_ID: null,
            bill_receipt_id: null,
            bill_module_type: '',
            patientId: null,
            isCredit: false,
            successText: ''
        }))
        if (props?.forReceivePayment) {
            getPatientDetails(PatientDetails?.ip_admission_id)
            clearFunction()
        } else {
            clearFunction(true)
        }
        if (getCachevalue('FromOtherScreen') === 'true' && getCachevalue('FromCreate') === 'false') {
            clearCachevalue('isForCancelBill')
            clearCachevalue('BillType')
            clearCachevalue('FromOtherScreen')
            let path = getCachevalue('path')
            history?.push({ pathname: path, state: {} })
            setTimeout(() => clearCachevalue('path'), 50)
        }
    }

    return (
        <Box component={'div'}>
            <Box component={'div'} sx={{ height: '80dvh', backgroundColor: STYLES.BACKGROUND_COLOR }}>
                {props?.forReceivePayment ? renderPatientDetails() :
                    <Box component={'div'} height={'10dvh'} p={'0.5rem'} display={'flex'}>
                        {newAmountCard('Total Patient', cashCount.tlt_patient, true, 'white', false, 'white', 'tlt_pat', '8dvw', '', '8dvh')}
                        {newAmountCard('Total Bills', cashCount.tlt_bills, true, 'white', false, 'white', 'tlt_bills', '8dvw', '0.5rem', '8dvh')}
                        {newAmountCard('Bill Amount', cashCount.tlt_bill_amt, false, 'white', false, 'white', 'tlt_bill_amt', '8dvw', '0.5rem', '8dvh')}
                        {newAmountCard('Credit Amount', cashCount.tlt_credit_amt, false, 'white', false, 'white', 'tlt_crdt', '8dvw', '0.5rem', '8dvh')}
                        {newAmountCard('Cancelled Bills', cashCount.tlt_cancelled_bill, true, 'white', false, 'white', 'tlt_rfd', '8dvw', '0.5rem', '8dvh')}
                        {newAmountCard('Refund Amount', cashCount.tlt_refund_amt, false, 'white', false, 'white', 'tlt_cal', '8dvw', '0.5rem', '8dvh')}
                        <Button className='Common_Btn_Min_Width eMed_Recpt_header_amt_card'
                            onClick={() => setCashCount((prev) => ({ ...prev, openReceipt: !cashCount.openReceipt }))}
                        >{newAmountCard('Receipt Amount', cashCount.tlt_receipt_amt, false, cashCount.openReceipt ? Colors.Primary : 'white', true, cashCount.openReceipt ? 'white' : Colors.Primary, 'tlt_rpt', '8dvw', '0.5rem', '8dvh')}</Button>
                        <Box component={'div'} display={'flex'} width={'33dvw'} overflow={'auto'}>
                            {cashCount.openReceipt ?
                                <Box sx={{ display: 'flex', flexDirection: "row", mt: '0.2rem' }}>
                                    <Grow in={cashCount.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                        {...(cashCount.openReceipt ? { timeout: 500 } : {})}>{newAmountCard('Cash', cashCount.tlt_cash_amt, false, 'white', false, 'white', 'tlt_cash', '8dvw', '0.5rem', '6dvh')}</Grow>
                                    <Grow in={cashCount.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                        {...(cashCount.openReceipt ? { timeout: 1000 } : {})}>{newAmountCard('Card', cashCount.tlt_card_amt, false, 'white', false, 'white', 'tlt_card', '8dvw', '0.5rem', '6dvh')}</Grow>
                                    <Grow in={cashCount.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                        {...(cashCount.openReceipt ? { timeout: 1500 } : {})}>{newAmountCard('UPI', cashCount.tlt_upi_amt, false, 'white', false, 'white', 'tlt_upi', '8dvw', '0.5rem', '6dvh')}</Grow>
                                    <Grow in={cashCount.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                        {...(cashCount.openReceipt ? { timeout: 2000 } : {})}>{newAmountCard('Bank', cashCount.tlt_bank_amt, false, 'white', false, 'white', 'tlt_bank', '8dvw', '0.5rem', '6dvh')}</Grow>
                                    <Grow in={cashCount.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                        {...(cashCount.openReceipt ? { timeout: 2500 } : {})}>{newAmountCard('Cheque', cashCount.tlt_cheque_amt, false, 'white', false, 'white', 'tlt_cheque', '8dvw', '0.5rem', '6dvh')}</Grow>
                                </Box> : null}
                        </Box>
                    </Box>}
                <Box component={'div'} height={STYLES.MAIN_CARD_HEIGHT} m={'0rem 0.5rem'}>
                    <Box border={'1px solid lightgray'}>
                        <Box sx={{ width: '59dvw' }} >
                            {renderGridOne()}
                        </Box>
                    </Box>
                    <Grid container>
                        <Grid xs={8}>{renderGridTwo()}</Grid>
                        <Grid xs={4}>{renderGridThree()}</Grid>
                    </Grid>
                </Box>
            </Box >
            {PatientSelectionPopup()}
            {
                message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {successPopup.bill_receipt_id !== null ? <BillSuccessPoPUp isDirectPrint={true} isFromOP={((loginInfo?.module_name === "Laboratory") || (loginInfo?.module_name === "Radiology") || (loginInfo?.module_name === "Investigation") || (loginInfo?.module_name === "Pharmacy") || location?.states?.refund_details?.pharmacy_id) ? false : true} isFromLab={loginInfo?.module_name === "Laboratory"} isFromRad={loginInfo?.module_name === "Radiology"} isFromPharmacy={loginInfo?.module_name === "Pharmacy" || location?.states?.refund_details?.pharmacy_id} CloseBtnText={'Close'} isCredit={successPopup.isCredit} moduleType={props?.forReceivePayment ? "IP" : loginInfo?.module_name === "Pharmacy" ? 'PHARMACY' : location?.states?.refund_details?.pharmacy_id ? successPopup?.bill_module_type || 'PHARMACY' : cashCount.moduleType} creditreceipt={successPopup.bill_receipt_id} patientID={successPopup.patiendId} ClosePopUp={ClosePopUp} successTxt={successPopup.successText} patientData={cashCount?.patient_details} isFromQuick={true} is_safety_deposit={cashCount.advance_type === 'safety_deposit' ? true : false} is_from_cash_counter={true} /> : null}
            {
                message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            <Loader loaderOpen={isLoader} />
        </Box >
    );
};

export default CashCounter;